const MIT_LICENSE_LIST = [
    [
        "@azure-rest/core-client 2.5.1 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/abort-controller 2.1.2 (MIT)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "@azure/communication-common 2.4.0 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "rgbcolor 1.0.1 (MIT)",
        "Copyright (c) 2016 Stoyan Stefanov, <http://phpied.com/>"
    ],
    [
        "@azure/communication-email 1.1.0 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/core-auth 1.10.1 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/core-client 1.10.1 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/core-lro 2.7.2 (MIT)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "@azure/core-rest-pipeline 1.22.2 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/core-tracing 1.3.1 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/core-util 1.13.1 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@azure/logger 1.3.0 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@babel/code-frame 7.26.2 (MIT)",
        "Copyright (c) 2014-present Sebastian McKenzie and other contributor"
    ],
    [
        "@babel/helper-validator-identifier 7.25.9 (MIT)",
        "Copyright (c) 2014-present Sebastian McKenzie and other contributors"
    ],
    [
        "@babel/runtime 7.28.3 (MIT)",
        "Copyright (c) 2014-present Sebastian McKenzie and other contributors"
    ],
    [
        "@babel/runtime 7.28.6 (MIT)",
        "Copyright (c) 2014-present Sebastian McKenzie and other contributors"
    ],
    [
        "@borewit/text-codec 0.2.2 (MIT)",
        "Copyright © 2025 Borewit"
    ],
    [
        "@colors/colors 1.6.0 (MIT)",
        "Copyright (c) Marak Squires"
    ],
    [
        "@dabh/diagnostics 2.0.3 (MIT)",
        "Copyright (c) 2015 Arnout Kazemier, Martijn Swaagman, the Contributors."
    ],
    [
        "@dabh/diagnostics 2.0.8 (MIT)",
        "Copyright (c) 2015 Arnout Kazemier, Martijn Swaagman, the Contributors."
    ],
    [
        "@date-fns/tz 1.4.1 (MIT)",
        "Copyright © 2024 Sasha Koss"
    ],
    [
        "@emotion/is-prop-valid 0.8.8 (MIT)",
        "Copyright (c) Emotion team and other contributors"
    ],
    [
        "@emotion/memoize 0.7.4 (MIT)",
        "Copyright (c) Emotion team and other contributors"
    ],
    [
        "@esbuild/aix-ppc64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/aix-ppc64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/android-arm 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/android-arm 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/android-arm64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/android-arm64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/android-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/android-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/darwin-arm64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/darwin-arm64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/darwin-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/darwin-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/freebsd-arm64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/freebsd-arm64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/freebsd-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/freebsd-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-arm 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-arm 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-arm64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-arm64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-ia32 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-ia32 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-loong64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-loong64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-mips64el 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-mips64el 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-ppc64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-ppc64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-riscv64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-riscv64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-s390x 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-s390x 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/linux-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/netbsd-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/netbsd-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/openbsd-arm64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/openbsd-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/openbsd-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/sunos-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/sunos-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/win32-arm64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/win32-arm64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/win32-ia32 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/win32-ia32 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/win32-x64 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@esbuild/win32-x64 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "@fast-csv/format 4.3.5 (MIT)",
        "Copyright (c) 2011-2026 C2FO"
    ],
    [
        "@fast-csv/parse 4.3.6 (MIT)",
        "Copyright (c) 2011-2026 C2FO"
    ],
    [
        "@floating-ui/core 1.7.3 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@floating-ui/core 1.7.4 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@floating-ui/dom 1.7.3 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@floating-ui/dom 1.7.5 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@floating-ui/react-dom 2.1.5 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@floating-ui/react-dom 2.1.7 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@floating-ui/utils 0.2.10 (MIT)",
        "Copyright (c) 2021 Floating UI contributors"
    ],
    [
        "@jridgewell/gen-mapping 0.3.13 (MIT)",
        "Copyright (c) Justin Ridgewell <justin@ridgewell.name>"
    ],
    [
        "@jridgewell/remapping 2.3.5 (MIT)",
        "Copyright (c) Justin Ridgewell <justin@ridgewell.name>"
    ],
    [
        "@jridgewell/resolve-uri 3.1.2 (MIT)",
        "Copyright 2019 Justin Ridgewell <jridgewell@google.com>"
    ],
    [
        "@jridgewell/sourcemap-codec 1.5.5 (MIT)",
        "Copyright (c) Justin Ridgewell <justin@ridgewell.name>"
    ],
    [
        "@jridgewell/trace-mapping 0.3.30 (MIT)",
        "Copyright (c) Justin Ridgewell <justin@ridgewell.name>"
    ],
    [
        "@jridgewell/trace-mapping 0.3.31 (MIT)",
        "Copyright (c) Justin Ridgewell <justin@ridgewell.name>"
    ],
    [
        "@lukeed/csprng 1.1.0 (MIT)",
        "Copyright (c) Luke Edwards"
    ],
    [
        "@microsoft/tsdoc 0.15.1 (MIT)",
        "Copyright (c) Microsoft Corporation. All rights reserved."
    ],
    [
        "@nestjs/common 10.3.0 (MIT)",
        "Copyright (c) 2017-2023 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/common 10.4.22 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/core 10.4.15 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/core 10.4.22 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/jwt 10.2.0 (MIT)",
        "Copyright (c) 2018-2022 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/mapped-types 2.0.5 (MIT)",
        "Copyright (c) 2020-2022 Kamil Mysliwiec"
    ],
    [
        "@nestjs/platform-express 10.4.15 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/platform-express 10.4.22 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/platform-socket.io 10.4.19 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/platform-socket.io 10.4.22 (MIT)",
        "Copyright (c) 2017-2024 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nestjs/schedule 4.1.1 (MIT)",
        "Copyright (c) Kamil Mysliwiec"
    ],
    [
        "@nestjs/schedule 4.1.2 (MIT)",
        "Copyright (c) Kamil Mysliwiec"
    ],
    [
        "@nestjs/serve-static 4.0.2 (MIT)",
        "Copyright (c)"
    ],
    [
        "@nestjs/swagger 7.4.2 (MIT)",
        "Copyright (c) 2020-2022 Kamil Mysliwiec"
    ],
    [
        "@nestjs/websockets 10.4.22 (MIT)",
        "Copyright (c) 2017-2023 Kamil Mysliwiec <https://kamilmysliwiec.com>"
    ],
    [
        "@nuxtjs/opencollective 0.3.2 (MIT)",
        "Copyright (c) 2018 Nuxt Community"
    ],
    [
        "@octokit/auth-token 6.0.0 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/core 7.0.4 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/core 7.0.6 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/endpoint 11.0.0 (MIT)",
        "Copyright (c) 2018 Octokit contributors"
    ],
    [
        "@octokit/endpoint 11.0.2 (MIT)",
        "Copyright (c) 2018 Octokit contributors"
    ],
    [
        "@octokit/graphql 9.0.1 (MIT)",
        "Copyright (c) 2018 Octokit contributors"
    ],
    [
        "@octokit/graphql 9.0.3 (MIT)",
        "Copyright (c) 2018 Octokit contributors"
    ],
    [
        "@octokit/openapi-types 25.1.0 (MIT)",
        "Copyright (c) GitHub 2025"
    ],
    [
        "@octokit/openapi-types 26.0.0 (MIT)",
        "Copyright (c) GitHub 2025"
    ],
    [
        "@octokit/openapi-types 27.0.0 (MIT)",
        "Copyright (c) GitHub 2025"
    ],
    [
        "@octokit/plugin-paginate-rest 13.1.1 (MIT)",
        "MIT License Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/plugin-paginate-rest 14.0.0 (MIT)",
        "MIT License Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/plugin-request-log 6.0.0 (MIT)",
        "MIT License Copyright (c) 2020 Octokit contributors"
    ],
    [
        "@octokit/plugin-rest-endpoint-methods 16.1.0 (MIT)",
        "MIT License Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/plugin-rest-endpoint-methods 17.0.0 (MIT)",
        "MIT License Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/request 10.0.3 (MIT)",
        "Copyright (c) 2018 Octokit contributors"
    ],
    [
        "@octokit/request 10.0.7 (MIT)",
        "Copyright (c) 2018 Octokit contributors"
    ],
    [
        "@octokit/request-error 7.0.0 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/request-error 7.1.0 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/rest 22.0.0 (MIT)",
        "Copyright (c) 2012 Cloud9 IDE, Inc. (Mike de Boer) Copyright (c) 2017-2018 Octokit contributors"
    ],
    [
        "@octokit/rest 22.0.1 (MIT)",
        "Copyright (c) 2017-2018 Octokit contributors,Copyright (c) 2012 Cloud9 IDE, Inc. (Mike de Boer)"
    ],
    [
        "@octokit/types 14.1.0 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/types 15.0.0 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@octokit/types 16.0.0 (MIT)",
        "Copyright (c) 2019 Octokit contributors"
    ],
    [
        "@popperjs/core 2.11.8 (MIT)",
        "Copyright (c) 2019 Federico Zivolo"
    ],
    [
        "@radix-ui/number 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/primitive 1.1.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-accordion 1.2.12 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-alert-dialog 1.1.15 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-arrow 1.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-aspect-ratio 1.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-aspect-ratio 1.1.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-avatar 1.1.10 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-avatar 1.1.11 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-checkbox 1.3.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-collapsible 1.1.12 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-collection 1.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-compose-refs 1.1.2 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-context 1.1.2 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-context 1.1.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-context-menu 2.2.16 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-dialog 1.1.15 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-direction 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-dismissable-layer 1.1.11 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-dropdown-menu 2.1.16 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-focus-guards 1.1.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-focus-scope 1.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-hover-card 1.1.15 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-id 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-label 2.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-label 2.1.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-menu 2.1.16 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-menubar 1.1.16 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-navigation-menu 1.2.14 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-popover 1.1.15 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-popper 1.2.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-portal 1.1.9 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-presence 1.1.5 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-primitive 2.1.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-primitive 2.1.4 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-progress 1.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-progress 1.1.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-radio-group 1.3.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-roving-focus 1.1.11 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-scroll-area 1.2.10 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-select 2.2.6 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-separator 1.1.7 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-separator 1.1.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-slider 1.3.6 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-slot 1.2.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-slot 1.2.4 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-switch 1.2.6 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-tabs 1.1.13 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-toast 1.2.15 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-toggle 1.1.10 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-toggle-group 1.1.11 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-tooltip 1.2.8 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-callback-ref 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-controllable-state 1.2.2 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-effect-event 0.0.2 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-escape-keydown 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-is-hydrated 0.1.0 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-layout-effect 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-previous 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-rect 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-use-size 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/react-visually-hidden 1.2.3 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@radix-ui/rect 1.1.1 (MIT)",
        "Copyright (c) 2022 WorkOS"
    ],
    [
        "@react-dnd/asap 5.0.2 (MIT)",
        "Copyright (c) 2015 Dan Abramov"
    ],
    [
        "@react-dnd/invariant 4.0.2 (MIT)",
        "Copyright (c) 2015 Dan Abramov"
    ],
    [
        "@react-dnd/shallowequal 4.0.2 (MIT)",
        "Copyright (c) 2015 Dan Abramov"
    ],
    [
        "@rollup/rollup-android-arm-eabi 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-android-arm-eabi 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-android-arm64 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-android-arm64 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-darwin-arm64 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-darwin-arm64 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-darwin-x64 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-darwin-x64 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-freebsd-arm64 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-freebsd-arm64 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-freebsd-x64 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-freebsd-x64 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm-gnueabihf 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm-gnueabihf 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm-musleabihf 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm-musleabihf 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm64-gnu 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm64-gnu 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm64-musl 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-arm64-musl 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-loongarch64-gnu 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-riscv64-gnu 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-riscv64-gnu 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-s390x-gnu 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-s390x-gnu 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-x64-gnu 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-x64-gnu 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-x64-musl 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-linux-x64-musl 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-arm64-msvc 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-arm64-msvc 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-ia32-msvc 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-ia32-msvc 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-x64-gnu 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-x64-msvc 4.46.3 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@rollup/rollup-win32-x64-msvc 4.60.0 (MIT)",
        "Copyright 2018 Rich Harris"
    ],
    [
        "@socket.io/component-emitter 3.1.0 (MIT)",
        "Copyright (c) 2014-2018 Automattic <dev@cloudup.com>"
    ],
    [
        "@socket.io/component-emitter 3.1.2 (MIT)",
        "Copyright (c) 2014-2018 Automattic <dev@cloudup.com>"
    ],
    [
        "@standard-schema/spec 1.0.0 (MIT)",
        "Copyright (c) 2024 Colin McDonnell"
    ],
    [
        "@standard-schema/spec 1.1.0 (MIT)",
        "Copyright (c) 2024 Colin McDonnell"
    ],
    [
        "@stripe/react-stripe-js 4.0.2 (MIT)",
        "Copyright (c) 2017 Stripe"
    ],
    [
        "@stripe/stripe-js 7.9.0 (MIT)",
        "Copyright (c) 2017 Stripe"
    ],
    [
        "@tailwindcss/node 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/node 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-android-arm64 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-android-arm64 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-darwin-arm64 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-darwin-arm64 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-darwin-x64 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-darwin-x64 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-freebsd-x64 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-freebsd-x64 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-arm-gnueabihf 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-arm-gnueabihf 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-arm64-gnu 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-arm64-gnu 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-arm64-musl 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-arm64-musl 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-x64-gnu 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-x64-gnu 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-x64-musl 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-linux-x64-musl 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-wasm32-wasi 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-wasm32-wasi 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-win32-arm64-msvc 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-win32-arm64-msvc 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-win32-x64-msvc 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/oxide-win32-x64-msvc 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/vite 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tailwindcss/vite 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "@tanstack/query-core 5.85.6 (MIT)",
        "Copyright (c) 2021-present Tanner Linsley"
    ],
    [
        "@tanstack/query-core 5.90.20 (MIT)",
        "Copyright (c) 2021-present Tanner Linsley"
    ],
    [
        "@tanstack/react-query 5.85.6 (MIT)",
        "Copyright (c) 2021-present Tanner Linsley"
    ],
    [
        "@tanstack/react-query 5.90.20 (MIT)",
        "Copyright (c) 2021-present Tanner Linsley"
    ],
    [
        "@tokenizer/inflate 0.4.1 (MIT)",
        "Copyright (c) 2024, Borewit"
    ],
    [
        "@tokenizer/token 0.3.0 (MIT)",
        "Copyright (c) 2020 Borewit"
    ],
    [
        "@tootallnate/quickjs-emscripten 0.23.0 (MIT)",
        "quickjs-emscripten copyright (c) 2019-2024 Jake Teton-Landis"
    ],
    [
        "@types/body-parser 1.19.2 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/body-parser 1.19.6 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/connect 3.4.35 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/connect 3.4.38 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/cors 2.8.17 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/cors 2.8.19 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/estree 1.0.8 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/express 4.17.21 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/express 4.17.25 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/express-serve-static-core 4.17.35 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/express-serve-static-core 4.19.8 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/history 4.7.11 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/http-errors 2.0.1 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/http-errors 2.0.5 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/jsonwebtoken 9.0.5 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/luxon 3.4.2 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/mime 1.3.2 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/mime 1.3.5 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/multer 1.4.11 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/multer 2.1.0 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/node 14.18.54 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/node 14.18.63 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/node 20.10.6 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/node 20.19.11 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/node 20.19.33 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/pako 2.0.4 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/pdfkit 0.17.4 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/pdfkit 0.17.5 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/pdfmake 0.3.2 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/prop-types 15.7.15 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/qs 6.14.0 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/qs 6.9.7 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/raf 3.4.3 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/range-parser 1.2.4 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/range-parser 1.2.7 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/react 18.3.23 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/react 18.3.28 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/react-dom 18.3.7 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/react-router 5.1.20 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/react-router-dom 5.3.3 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/send 0.17.1 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/send 0.17.6 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/send 1.2.1 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/serve-static 1.15.10 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/serve-static 1.15.2 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/triple-beam 1.3.5 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/trusted-types 2.0.7 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/validator 13.15.10 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/validator 13.7.17 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@types/yauzl 2.10.3 (MIT)",
        "Copyright (c) Microsoft Corporation."
    ],
    [
        "@typespec/ts-http-runtime 0.3.2 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@typespec/ts-http-runtime 0.3.3 (MIT)",
        "Copyright (c) 2018 Microsoft"
    ],
    [
        "@xmldom/xmldom 0.8.7 (MIT)",
        "Copyright 2019 - present Christopher J. Brody and other contributors, as listed in: <https://github.com/xmldom/xmldom/graphs/contributors> Copyright 2012 - 2017 @jindw <jindw@xidea.org> and other contributors, as listed in: <https://github.com/jindw/xmldom/graphs/contributors>"
    ],
    [
        "accepts 1.3.8 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com>"
    ],
    [
        "agent-base 6.0.2 (MIT)",
        "Copyright (c) 2013 Nathan Rajlich <nathan@tootallnate.net>"
    ],
    [
        "agent-base 7.1.0 (MIT)",
        "Copyright (c) 2013 Nathan Rajlich <nathan@tootallnate.net>"
    ],
    [
        "agent-base 7.1.3 (MIT)",
        "Copyright (c) 2013 Nathan Rajlich <nathan@tootallnate.net>"
    ],
    [
        "agent-base 7.1.4 (MIT)",
        "Copyright (c) 2013 Nathan Rajlich <nathan@tootallnate.net>"
    ],
    [
        "ansi-regex 5.0.1 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "ansi-styles 4.3.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "append-field 1.0.0 (MIT)",
        "Copyright (c) 2015-2021 Linus Unnebäck"
    ],
    [
        "archiver 5.3.1 (MIT)",
        "Copyright (c) 2012-2014 Chris Talkington, contributors."
    ],
    [
        "archiver 5.3.2 (MIT)",
        "Copyright (c) 2012-2014 Chris Talkington, contributors."
    ],
    [
        "archiver-utils 2.1.0 (MIT)",
        "Copyright (c) 2015 Chris Talkington."
    ],
    [
        "archiver-utils 3.0.4 (MIT)",
        "Copyright (c) 2015 Chris Talkington."
    ],
    [
        "argparse 2.0.1 (MIT)",
        "Copyright (c) 1991 - 1995, Stichting Mathematisch Centrum Amsterdam, The Netherlands"
    ],
    [
        "aria-hidden 1.2.6 (MIT)",
        "Copyright (c) 2017 Anton Korzunov"
    ],
    [
        "array-flatten 1.1.1 (MIT)",
        "Copyright (c) 2014 Blake Embrey (<hello@blakeembrey.com>)"
    ],
    [
        "ast-types 0.13.4 (MIT)",
        "Copyright (c) 2013 Ben Newman <bn@cs.stanford.edu>"
    ],
    [
        "async 3.2.4 (MIT)",
        "Copyright (c) 2010-2018 Caolan McMahon"
    ],
    [
        "async 3.2.6 (MIT)",
        "Copyright (c) 2010-2018 Caolan McMahon"
    ],
    [
        "asynckit 0.4.0 (MIT)",
        "Copyright (c) 2016 Alex Indigo"
    ],
    [
        "autoprefixer 10.4.21 (MIT)",
        "Copyright 2013 Andrey Sitnik <andrey@sitnik.ru>"
    ],
    [
        "axios 1.12.2 (MIT)",
        "Copyright (c) 2014-present Matt Zabriskie & Collaborators"
    ],
    [
        "axios 1.13.5 (MIT)",
        "Copyright (c) 2014-present Matt Zabriskie & Collaborators"
    ],
    [
        "axios 1.8.1 (MIT)",
        "Copyright (c) 2014-present Matt Zabriskie & Collaborators"
    ],
    [
        "balanced-match 1.0.2 (MIT)",
        "Copyright Isaac Z. Schlueter <i@izs.me>"
    ],
    [
        "balanced-match 4.0.4 (MIT)",
        "Copyright Isaac Z. Schlueter <i@izs.me>"
    ],
    [
        "base64-arraybuffer 1.0.2 (MIT)",
        "Copyright (c) 2012 Niklas von Hertzen"
    ],
    [
        "base64-js 0.0.8 (MIT)",
        "Copyright (c) 2014 Jameson Little"
    ],
    [
        "base64-js 1.5.1 (MIT)",
        "Copyright (c) 2014 Jameson Little"
    ],
    [
        "base64id 2.0.0 (MIT)",
        "Copyright (c) 2012-2016 Kristian Faeldt <faeldt_kristian@cyberagent.co.jp>"
    ],
    [
        "basic-auth 2.0.1 (MIT)",
        "Copyright (c) 2013 TJ Holowaychuk"
    ],
    [
        "basic-ftp 5.0.5 (MIT)",
        "Copyright (c) 2019 Patrick Juchli"
    ],
    [
        "bcrypt 5.1.1 (MIT)",
        "Copyright (c) 2010 Nicholas Campbell"
    ],
    [
        "bignumber.js 9.1.2 (MIT)",
        "Copyright (c) Michael Mclaughlin"
    ],
    [
        "binary 0.3.0 (MIT)",
        ""
    ],
    [
        "bl 4.1.0 (MIT)",
        "Copyright (c) 2013-2019 bl contributors"
    ],
    [
        "bluebird 3.4.7 (MIT)",
        "Copyright (c) 2013-2018 Petka Antonov"
    ],
    [
        "body-parser 1.20.3 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com>"
    ],
    [
        "body-parser 1.20.4 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com>"
    ],
    [
        "brace-expansion 1.1.11 (MIT)",
        "Copyright Julian Gruber <julian@juliangruber.com>"
    ],
    [
        "brace-expansion 2.0.1 (MIT)",
        "Copyright Julian Gruber <julian@juliangruber.com>"
    ],
    [
        "brace-expansion 5.0.4 (MIT)",
        "Copyright Julian Gruber <julian@juliangruber.com>"
    ],
    [
        "brotli 1.3.3 (MIT)",
        "Copyright (c) Devon Govett <devongovett@gmail.com>"
    ],
    [
        "browserslist 4.25.3 (MIT)",
        "Copyright 2014 Andrey Sitnik <andrey@sitnik.es> and other contributors"
    ],
    [
        "buffer 5.7.1 (MIT)",
        "Copyright Node.js contributors. All rights reserved."
    ],
    [
        "buffer-crc32 0.2.13 (MIT)",
        "Copyright (c) 2013-2024 Brian J. Brennan"
    ],
    [
        "buffer-crc32 1.0.0 (MIT)",
        "Copyright (c) 2013-2024 Brian J. Brennan"
    ],
    [
        "buffer-from 1.1.2 (MIT)",
        "Copyright (c) 2016, 2018 Linus Unnebäck"
    ],
    [
        "buffer-indexof-polyfill 1.0.2 (MIT)",
        "Copyright (c) 2015 Sarosia"
    ],
    [
        "busboy 1.6.0 (MIT)",
        "Copyright Brian White. All rights reserved."
    ],
    [
        "bytes 3.1.2 (MIT)",
        "Copyright (c) 2015 Jed Watson <jed.watson@me.com>"
    ],
    [
        "c12 3.1.0 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "call-bind-apply-helpers 1.0.2 (MIT)",
        "Copyright (c) 2024 Jordan Harband"
    ],
    [
        "callsites 3.1.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "canvg 3.0.11 (MIT)",
        "Copyright (c) 2010 - present Gabe Lerner (<gabelerner@gmail.com>) - <https://github.com/canvg/canvg>"
    ],
    [
        "chainsaw 0.1.0 (MIT)",
        ""
    ],
    [
        "chalk 4.1.2 (MIT)",
        "Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)"
    ],
    [
        "chokidar 4.0.3 (MIT)",
        "Copyright (c) 2012 Paul Miller (<https://paulmillr.com>), Elan Shanker"
    ],
    [
        "citty 0.1.6 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "citty 0.2.0 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "class-transformer 0.5.1 (MIT)",
        "Copyright (c) 2015-2020 TypeStack"
    ],
    [
        "class-validator 0.14.0 (MIT)",
        "Copyright (c) 2015-2020 TypeStack"
    ],
    [
        "classnames 2.5.1 (MIT)",
        "Copyright (c) 2018 Jed Watson"
    ],
    [
        "clone 2.1.2 (MIT)",
        "Copyright © 2011-2015 Paul Vorbach <paul@vorba.ch>"
    ],
    [
        "clsx 2.1.1 (MIT)",
        "Copyright (c) Luke Edwards"
    ],
    [
        "cmdk 1.1.1 (MIT)",
        "Copyright (c) 2022 Paco Coursey"
    ],
    [
        "color 3.2.1 (MIT)",
        "Copyright (c) 2012 Heather Arthur"
    ],
    [
        "color 5.0.3 (MIT)",
        "Copyright (c) 2012 Heather Arthur"
    ],
    [
        "color-convert 1.9.3 (MIT)",
        "Copyright (c) 2016-2021 Josh Junon <josh@junon.me>."
    ],
    [
        "color-convert 2.0.1 (MIT)",
        "Copyright (c) 2016-2021 Josh Junon <josh@junon.me>."
    ],
    [
        "color-convert 3.1.3 (MIT)",
        "Copyright (c) 2016-2021 Josh Junon <josh@junon.me>."
    ],
    [
        "color-name 1.1.3 (MIT)",
        "Copyright (c) 2015 Dmitry Ivanov"
    ],
    [
        "color-name 1.1.4 (MIT)",
        "Copyright (c) 2015 Dmitry Ivanov"
    ],
    [
        "color-name 2.1.0 (MIT)",
        "Copyright (c) 2015 Dmitry Ivanov"
    ],
    [
        "color-string 1.9.1 (MIT)",
        "Copyright (c) 2011 Heather Arthur <fayearthur@gmail.com>"
    ],
    [
        "color-string 2.1.4 (MIT)",
        "Copyright (c) 2011 Heather Arthur <fayearthur@gmail.com>"
    ],
    [
        "colorspace 1.1.4 (MIT)",
        "Copyright (c) 2015 Arnout Kazemier, Martijn Swaagman, the Contributors."
    ],
    [
        "combined-stream 1.0.8 (MIT)",
        "Copyright (c) Felix Geisendörfer <felix@debuggable.com> (<http://debuggable.com/>)"
    ],
    [
        "compress-commons 4.1.1 (MIT)",
        "Copyright (c) 2014 Chris Talkington, contributors."
    ],
    [
        "compress-commons 4.1.2 (MIT)",
        "Copyright (c) 2014 Chris Talkington, contributors."
    ],
    [
        "concat-map 0.0.1 (MIT)",
        ""
    ],
    [
        "concat-stream 1.6.2 (MIT)",
        "Copyright (c) 2013 Max Ogden"
    ],
    [
        "concat-stream 2.0.0 (MIT)",
        "Copyright (c) 2013 Max Ogden"
    ],
    [
        "confbox 0.2.2 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "confbox 0.2.4 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "consola 2.15.3 (MIT)",
        "Copyright (c) Nate Moore"
    ],
    [
        "consola 3.4.2 (MIT)",
        "Copyright (c) Nate Moore"
    ],
    [
        "content-disposition 0.5.4 (MIT)",
        "Copyright (c) 2014-2017 Douglas Christopher Wilson"
    ],
    [
        "content-type 1.0.5 (MIT)",
        "Copyright (c) 2015 Douglas Christopher Wilson"
    ],
    [
        "cookie 0.7.1 (MIT)",
        "Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>"
    ],
    [
        "cookie 0.7.2 (MIT)",
        "Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>"
    ],
    [
        "cookie 1.0.2 (MIT)",
        "Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>"
    ],
    [
        "cookie 1.1.1 (MIT)",
        "Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>"
    ],
    [
        "cookie-signature 1.0.6 (MIT)",
        "Copyright (c) 2012 LearnBoost <tj@learnboost.com>"
    ],
    [
        "cookie-signature 1.0.7 (MIT)",
        "Copyright (c) 2012 LearnBoost <tj@learnboost.com>"
    ],
    [
        "core-js 3.45.1 (MIT)",
        "Copyright (c) 2025-2026 CoreJS Company (core-js.io)"
    ],
    [
        "core-util-is 1.0.3 (MIT)",
        "Copyright Node.js contributors. All rights reserved."
    ],
    [
        "cors 2.8.5 (MIT)",
        "Copyright (c) 2013 Troy Goode <troygoode@gmail.com>"
    ],
    [
        "cosmiconfig 9.0.0 (MIT)",
        "Copyright (c) 2015 David Clark"
    ],
    [
        "crc32-stream 4.0.2 (MIT)",
        "Copyright (c) 2014 Chris Talkington, contributors."
    ],
    [
        "crc32-stream 4.0.3 (MIT)",
        "Copyright (c) 2014 Chris Talkington, contributors."
    ],
    [
        "cron 3.1.7 (MIT)",
        "Copyright © 2017 Nicholas Campbell <nicholas.j.campbell@gmail.com>"
    ],
    [
        "cron 3.2.1 (MIT)",
        "Copyright © 2017 Nicholas Campbell <nicholas.j.campbell@gmail.com>"
    ],
    [
        "crypto-js 4.2.0 (MIT)",
        "Copyright (c) 2009-2013 Jeff Mott"
    ],
    [
        "css-line-break 2.1.0 (MIT)",
        "Copyright (c) 2017 Niklas von Hertzen"
    ],
    [
        "csstype 3.1.3 (MIT)",
        "Copyright (c) 2017-2018 Fredrik Nicol"
    ],
    [
        "csstype 3.2.3 (MIT)",
        "Copyright (c) 2017-2018 Fredrik Nicol"
    ],
    [
        "csv-parse 5.5.3 (MIT)",
        "Copyright (c) 2010 Adaltas"
    ],
    [
        "data-uri-to-buffer 6.0.2 (MIT)",
        "Copyright (c) 2014 Nathan Rajlich <nathan@tootallnate.net>"
    ],
    [
        "date-fns 2.30.0 (MIT)",
        "Copyright (c) 2021 Sasha Koss and Lesha Koss <https://kossnocorp.mit-license.org>"
    ],
    [
        "date-fns 4.1.0 (MIT)",
        "Copyright (c) 2021 Sasha Koss and Lesha Koss <https://kossnocorp.mit-license.org>"
    ],
    [
        "date-fns-jalali 4.1.0-0 (MIT)",
        "Copyright (c) 2021 Sasha Koss and Lesha Koss <https://kossnocorp.mit-license.org>"
    ],
    [
        "dayjs 1.11.19 (MIT)",
        "Copyright (c) 2018-present, iamkun"
    ],
    [
        "dayjs 1.11.9 (MIT)",
        "Copyright (c) 2018-present, iamkun"
    ],
    [
        "debug 2.6.9 (MIT)",
        "Copyright (c) 2018-2021 Josh Junon"
    ],
    [
        "debug 4.3.4 (MIT)",
        "Copyright (c) 2018-2021 Josh Junon"
    ],
    [
        "debug 4.3.7 (MIT)",
        "Copyright (c) 2018-2021 Josh Junon"
    ],
    [
        "debug 4.4.0 (MIT)",
        "Copyright (c) 2018-2021 Josh Junon"
    ],
    [
        "debug 4.4.3 (MIT)",
        "Copyright (c) 2018-2021 Josh Junon"
    ],
    [
        "defu 6.1.4 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "degenerator 5.0.1 (MIT)",
        "Copyright (c) 2013 Nathan Rajlich <nathan@tootallnate.net>"
    ],
    [
        "delayed-stream 1.0.0 (MIT)",
        "Copyright (c) 2011 Debuggable Limited <felix@debuggable.com>"
    ],
    [
        "delegates 1.0.0 (MIT)",
        "Copyright (c) 2015 TJ Holowaychuk <tj@vision-media.ca>"
    ],
    [
        "depd 2.0.0 (MIT)",
        "Copyright (c) 2014-2018 Douglas Christopher Wilson"
    ],
    [
        "destr 2.0.5 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "destroy 1.2.0 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com> Copyright (c) 2015-2022 Douglas Christopher Wilson <doug@somethingdoug.com>"
    ],
    [
        "detect-node-es 1.1.0 (MIT)",
        "Copyright (c) 2017 Ilya Kantor"
    ],
    [
        "dfa 1.2.0 (MIT)",
        ""
    ],
    [
        "dnd-core 16.0.1 (MIT)",
        "Copyright (c) 2015 Dan Abramov"
    ],
    [
        "dunder-proto 1.0.1 (MIT)",
        "Copyright (c) 2024 ECMAScript Shims"
    ],
    [
        "easy-template-x 3.2.0 (MIT)",
        "Copyright (c) 2018 Alon Bar"
    ],
    [
        "ee-first 1.1.1 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com>"
    ],
    [
        "effect 3.16.12 (MIT)",
        "Copyright (c) 2023 Effectful Technologies Inc"
    ],
    [
        "effect 3.21.0 (MIT)",
        "Copyright (c) 2023 Effectful Technologies Inc"
    ],
    [
        "embla-carousel 8.6.0 (MIT)",
        "Copyright (c) David Jerleke."
    ],
    [
        "embla-carousel-react 8.6.0 (MIT)",
        "Copyright (c) David Jerleke."
    ],
    [
        "embla-carousel-reactive-utils 8.6.0 (MIT)",
        "Copyright (c) David Jerleke."
    ],
    [
        "emoji-regex 8.0.0 (MIT)",
        "Copyright Mathias Bynens <https://mathiasbynens.be/>"
    ],
    [
        "empathic 2.0.0 (MIT)",
        "Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)"
    ],
    [
        "enabled 2.0.0 (MIT)",
        "(Copyright information not explicitly found, licensed under MIT)"
    ],
    [
        "encodeurl 1.0.2 (MIT)",
        "Copyright (c) 2016 Douglas Christopher Wilson"
    ],
    [
        "encodeurl 2.0.0 (MIT)",
        "Copyright (c) 2016 Douglas Christopher Wilson"
    ],
    [
        "end-of-stream 1.4.4 (MIT)",
        "Copyright (c) 2014 Mathias Buus"
    ],
    [
        "end-of-stream 1.4.5 (MIT)",
        "Copyright (c) 2014 Mathias Buus"
    ],
    [
        "engine.io 6.6.4 (MIT)",
        "Copyright (c) 2014-present Guillermo Rauch and Socket.IO contributors"
    ],
    [
        "engine.io 6.6.5 (MIT)",
        "Copyright (c) 2014-present Guillermo Rauch and Socket.IO contributors"
    ],
    [
        "engine.io-client 6.6.3 (MIT)",
        "Copyright (c) 2014-present Guillermo Rauch and Socket.IO contributors"
    ],
    [
        "engine.io-client 6.6.4 (MIT)",
        "Copyright (c) 2014-present Guillermo Rauch and Socket.IO contributors"
    ],
    [
        "engine.io-parser 5.2.3 (MIT)",
        "Copyright (c) 2014-present Guillermo Rauch and Socket.IO contributors"
    ],
    [
        "enhanced-resolve 5.18.3 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "enhanced-resolve 5.19.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "enquire.js 2.1.6 (MIT)",
        "Copyright (c) 2012 Nick Williams"
    ],
    [
        "env-paths 2.2.1 (MIT)",
        "Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)"
    ],
    [
        "error-ex 1.3.2 (MIT)",
        "Copyright (c) 2015 JD Ballard"
    ],
    [
        "es-define-property 1.0.1 (MIT)",
        "Copyright (c) 2024 Jordan Harband"
    ],
    [
        "es-errors 1.3.0 (MIT)",
        "Copyright (c) 2024 Jordan Harband"
    ],
    [
        "es-object-atoms 1.1.1 (MIT)",
        "Copyright (c) 2024 Jordan Harband"
    ],
    [
        "es-set-tostringtag 2.1.0 (MIT)",
        "Copyright (c) 2022 ECMAScript Shims"
    ],
    [
        "es-shims-es5-shim (MIT)",
        "Copyright (C) 2009-2016 Kristopher Michael Kowal and contributors"
    ],
    [
        "esbuild 0.21.5 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "esbuild 0.25.12 (MIT)",
        "Copyright (c) 2020 Evan Wallace"
    ],
    [
        "escalade 3.2.0 (MIT)",
        "Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)"
    ],
    [
        "escape-html 1.0.3 (MIT)",
        "Copyright (c) 2012-2013 TJ Holowaychuk Copyright (c) 2015 Andreas Lubbe Copyright (c) 2015 Tiancheng \"Timothy\" Gu"
    ],
    [
        "etag 1.8.1 (MIT)",
        "Copyright (c) 2014-2016 Douglas Christopher Wilson"
    ],
    [
        "events 3.3.0 (MIT)",
        "Copyright Joyent, Inc. and other Node contributors."
    ],
    [
        "exceljs 4.4.0 (MIT)",
        "Copyright (c) 2014-2019 Guyon Roche"
    ],
    [
        "express 4.21.2 (MIT)",
        "Copyright (c) 2009-2014 TJ Holowaychuk <tj@vision-media.ca> Copyright (c) 2013-2014 Roman Shtylman <shtylman+expressjs@gmail.com> Copyright (c) 2014-2015 Douglas Christopher Wilson <doug@somethingdoug.com>"
    ],
    [
        "express 4.22.1 (MIT)",
        "Copyright (c) 2009-2014 TJ Holowaychuk <tj@vision-media.ca> Copyright (c) 2013-2014 Roman Shtylman <shtylman+expressjs@gmail.com> Copyright (c) 2014-2015 Douglas Christopher Wilson <doug@somethingdoug.com>"
    ],
    [
        "exsolve 1.0.8 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "extend 3.0.2 (MIT)",
        "Copyright (c) 2014 Stefan Thomas"
    ],
    [
        "fast-check 3.23.2 (MIT)",
        "Copyright (c) 2017 Nicolas DUBIEN"
    ],
    [
        "fast-content-type-parse 3.0.0 (MIT)",
        "Copyright (c) 2023 The Fastify Team"
    ],
    [
        "fast-csv 4.3.6 (MIT)",
        "Copyright (c) 2011-2019 C2FO"
    ],
    [
        "fast-deep-equal 3.1.3 (MIT)",
        "Copyright (c) 2017 Evgeny Poberezkin"
    ],
    [
        "fast-fifo 1.3.2 (MIT)",
        "Copyright (c) 2019 Mathias Buus"
    ],
    [
        "fast-png 6.4.0 (MIT)",
        "Copyright (c) 2015 Michaël Zasso"
    ],
    [
        "fast-safe-stringify 2.1.1 (MIT)",
        "Copyright (c) 2018 David Mark Clements"
    ],
    [
        "fd-slicer 1.1.0 (MIT)",
        "Copyright (c) 2014 Andrew Kelley"
    ],
    [
        "fdir 6.5.0 (MIT)",
        "Copyright 2023 Abdullah Atta"
    ],
    [
        "fecha 4.2.3 (MIT)",
        "Copyright (c) 2015 Taylor Hakes"
    ],
    [
        "fflate 0.8.2 (MIT)",
        "Copyright (c) 2020 101arrowz"
    ],
    [
        "file-type 21.3.4 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "finalhandler 1.3.1 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "finalhandler 1.3.2 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "fn.name 1.1.0 (MIT)",
        "Copyright (c) 2015 Arnout Kazemier, Martijn Swaagman, the Contributors."
    ],
    [
        "follow-redirects 1.15.9 (MIT)",
        "Copyright 2014-present Olivier Lalonde <olalonde@gmail.com>, James Talmage <james@talmage.io>, Ruben Verborgh"
    ],
    [
        "fontkit 2.0.4 (MIT)",
        "Copyright not found"
    ],
    [
        "form-data 4.0.0 (MIT)",
        "Copyright (c) 2012 Felix Geisendörfer"
    ],
    [
        "form-data 4.0.4 (MIT)",
        "Copyright (c) 2012 Felix Geisendörfer"
    ],
    [
        "form-data 4.0.5 (MIT)",
        "Copyright (c) 2012 Felix Geisendörfer"
    ],
    [
        "forwarded 0.2.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "fraction.js 4.3.7 (MIT)",
        "Copyright (c) 2023, Robert Eisele"
    ],
    [
        "framer-motion 10.18.0 (MIT)",
        "Copyright (c) 2018 Framer B.V."
    ],
    [
        "fresh 0.5.2 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "fs-constants 1.0.0 (MIT)",
        "Copyright (c) 2018 Mathias Buus"
    ],
    [
        "fsevents 2.3.3 (MIT)",
        "Copyright (C) 2010-2020 by Philipp Dunkel, Ben Noordhuis, Elan Shankar, Paul Miller"
    ],
    [
        "function-bind 1.1.2 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "get-intrinsic 1.3.0 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "get-nonce 1.0.1 (MIT)",
        "Copyright (c) 2020 Anton Korzunov"
    ],
    [
        "get-proto 1.0.1 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "get-stream 5.2.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "get-uri 6.0.4 (MIT)",
        "Copyright (c) Nathan Rajlich"
    ],
    [
        "giget 2.0.0 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "gopd 1.2.0 (MIT)",
        "Copyright (c) 2022 Jordan Harband"
    ],
    [
        "gtoken 7.0.1 (MIT)",
        "Copyright 2022 Google LLC"
    ],
    [
        "has-flag 4.0.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "has-symbols 1.1.0 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "has-tostringtag 1.0.2 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "hasown 2.0.2 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "helmet 7.1.0 (MIT)",
        "Copyright (c) 2012-2023 Evan Hahn, Adam Baldwin"
    ],
    [
        "helmet 7.2.0 (MIT)",
        "Copyright (c) 2012-2024 Evan Hahn, Adam Baldwin"
    ],
    [
        "html2canvas 1.4.1 (MIT)",
        "Copyright (c) 2012 Niklas von Hertzen"
    ],
    [
        "http-errors 2.0.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "http-errors 2.0.1 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "http-proxy-agent 7.0.2 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "httpntlm 1.6.1 (MIT)",
        "Copyright (c) 2013 Sam"
    ],
    [
        "httpreq 1.1.1 (MIT)",
        "Copyright not found"
    ],
    [
        "https-proxy-agent 5.0.1 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "https-proxy-agent 7.0.2 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "https-proxy-agent 7.0.6 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "iconv-lite 0.4.24 (MIT)",
        "Copyright (c) 2011 Alexander Shtuchkin"
    ],
    [
        "immediate 3.0.6 (MIT)",
        "Copyright (c) 2014 Matthew Williams"
    ],
    [
        "import-fresh 3.3.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "input-otp 1.4.2 (MIT)",
        "Copyright (c) 2024 Guilherme Rodz"
    ],
    [
        "iobuffer 5.4.0 (MIT)",
        "Copyright (c) 2015 Michaël Zasso"
    ],
    [
        "ip-address 9.0.5 (MIT)",
        "Copyright (c) Bevan Hunt"
    ],
    [
        "ipaddr.js 1.9.1 (MIT)",
        "Copyright (c) whitequark"
    ],
    [
        "is-arrayish 0.2.1 (MIT)",
        "Copyright (c) Julian Gruber"
    ],
    [
        "is-arrayish 0.3.2 (MIT)",
        "Copyright (c) Julian Gruber"
    ],
    [
        "is-fullwidth-code-point 3.0.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "is-stream 2.0.1 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "isarray 0.0.1 (MIT)",
        "Copyright (c) Raynos"
    ],
    [
        "isarray 1.0.0 (MIT)",
        "Copyright (c) Raynos"
    ],
    [
        "jiti 2.5.1 (MIT)",
        "Copyright (c) UnJS contributors"
    ],
    [
        "jiti 2.6.1 (MIT)",
        "Copyright (c) UnJS contributors"
    ],
    [
        "jpeg-exif 1.1.4 (MIT)",
        "Copyright (c) 2015 邵振华"
    ],
    [
        "js-tokens 4.0.0 (MIT)",
        "Copyright (c) 2014 Simon Lydell"
    ],
    [
        "js-yaml 4.1.0 (MIT)",
        "Copyright (c) nodeca contributors"
    ],
    [
        "js-yaml 4.1.1 (MIT)",
        "Copyright (c) nodeca contributors"
    ],
    [
        "jsbn 1.1.0 (MIT)",
        "Copyright (c) Tom Wu"
    ],
    [
        "json-bigint 1.0.0 (MIT)",
        "Copyright (c) 2013 Andrey Sidorov"
    ],
    [
        "json-parse-even-better-errors 2.3.1 (MIT)",
        "Copyright (c) npm, Inc. and Contributors"
    ],
    [
        "json2mq 0.2.0 (MIT)",
        "Copyright (c) akiran"
    ],
    [
        "jsonwebtoken 9.0.2 (MIT)",
        "Copyright (c) auth0"
    ],
    [
        "jspdf 3.0.2 (MIT)",
        "Copyright (c) parallax"
    ],
    [
        "jszip 3.10.1 (MIT)",
        "Copyright (c) Stuart Knightley"
    ],
    [
        "jwa 1.4.1 (MIT)",
        "Copyright (c) Michael B. Stewart"
    ],
    [
        "jwa 1.4.2 (MIT)",
        "Copyright (c) Michael B. Stewart"
    ],
    [
        "jwa 2.0.0 (MIT)",
        "Copyright (c) Michael B. Stewart"
    ],
    [
        "jws 3.2.2 (MIT)",
        "Copyright (c) Auth0, Inc."
    ],
    [
        "jws 3.2.3 (MIT)",
        "Copyright (c) Auth0, Inc."
    ],
    [
        "jws 4.0.0 (MIT)",
        "Copyright (c) Auth0, Inc."
    ],
    [
        "jwt-decode 4.0.0 (MIT)",
        "Copyright (c) Auth0, Inc."
    ],
    [
        "kuler 2.0.0 (MIT)",
        "Copyright 2014 Arnout Kazemier"
    ],
    [
        "lazystream 1.0.1 (MIT)",
        "Copyright (c) Tim Oxley"
    ],
    [
        "libphonenumber-js 1.10.38 (MIT)",
        "Copyright (c) 2014-2015 Rebecca Turner"
    ],
    [
        "libphonenumber-js 1.12.36 (MIT)",
        "Copyright (c) catamphetamine"
    ],
    [
        "lie 3.3.0 (MIT)",
        "Copyright (c) catamphetamine"
    ],
    [
        "linebreak 1.1.0 (MIT)",
        "Copyright (c) Parcel contributors"
    ],
    [
        "lines-and-columns 1.2.4 (MIT)",
        "Copyright (c) Parcel contributors"
    ],
    [
        "lodash 4.17.21 (MIT)",
        "Copyright (c) Adobe Systems Incorporated"
    ],
    [
        "lodash 4.17.23 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "lodash.debounce 4.0.8 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "lodash.defaults 4.2.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.difference 4.5.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.escaperegexp 4.1.2 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.flatten 4.4.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.get 4.4.2 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.groupby 4.6.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.includes 4.3.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isboolean 3.0.3 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isequal 4.5.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isfunction 3.0.9 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isinteger 4.0.4 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isnil 4.0.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isnumber 3.0.3 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isplainobject 4.0.6 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isstring 4.0.1 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.isundefined 3.0.1 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.once 4.1.1 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.union 4.6.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "lodash.uniq 4.5.0 (MIT)",
        "Copyright JS Foundation and other contributors"
    ],
    [
        "logform 2.6.0 (MIT)",
        "Copyright (c) 2017 Charlie Robbins & the Contributors."
    ],
    [
        "logform 2.7.0 (MIT)",
        "Copyright (c) 2017 Charlie Robbins & the Contributors."
    ],
    [
        "loose-envify 1.4.0 (MIT)",
        "Copyright (c) 2015 Dan Abramov"
    ],
    [
        "luxon 3.4.4 (MIT)",
        "Copyright (c) Isaac Cambron"
    ],
    [
        "luxon 3.5.0 (MIT)",
        "Copyright (c) Isaac Cambron"
    ],
    [
        "luxon 3.7.2 (MIT)",
        "Copyright (c) Isaac Cambron"
    ],
    [
        "magic-string 0.30.17 (MIT)",
        "Copyright (c) Rich Harris"
    ],
    [
        "magic-string 0.30.21 (MIT)",
        "Copyright (c) Rich Harris"
    ],
    [
        "make-dir 3.1.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "math-intrinsics 1.1.0 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "media-typer 0.3.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "merge-descriptors 1.0.3 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "methods 1.1.2 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "mime 1.6.0 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "mime-db 1.52.0 (MIT)",
        "Copyright (c) Jonathan Ong and Contributors"
    ],
    [
        "mime-types 2.1.35 (MIT)",
        "Copyright (c) Jonathan Ong and Contributors"
    ],
    [
        "minimatch 3.1.5 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minimatch 5.1.9 (MIT)",
        "Copyright (c) 2011-2023 Isaac Z. Schlueter and Contributors"
    ],
    [
        "minimist 1.2.8 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minizlib 2.1.2 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minizlib 3.0.2 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minizlib 3.1.0 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "mitt 3.0.1 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "mkdirp 0.5.6 (MIT)",
        "Copyright (c) Jason Miller"
    ],
    [
        "mkdirp 1.0.4 (MIT)",
        "Copyright (c) Substack"
    ],
    [
        "mkdirp 3.0.1 (MIT)",
        "Copyright (c) Substack"
    ],
    [
        "morgan 1.10.0 (MIT)",
        "Copyright (c) Substack"
    ],
    [
        "morgan 1.10.1 (MIT)",
        "Copyright (c) Express contributors"
    ],
    [
        "ms 2.0.0 (MIT)",
        "Copyright (c) Express contributors"
    ],
    [
        "ms 2.1.2 (MIT)",
        "Copyright (c) Guillermo Rauch"
    ],
    [
        "ms 2.1.3 (MIT)",
        "Copyright (c) Guillermo Rauch"
    ],
    [
        "multer 1.4.4-lts.1 (MIT)",
        "Copyright (c) Guillermo Rauch"
    ],
    [
        "multer 1.4.5-lts.1 (MIT)",
        "Copyright (c) Express contributors"
    ],
    [
        "multer 2.1.1 (MIT)",
        "Copyright (c) Express contributors"
    ],
    [
        "nanoid 3.3.11 (MIT)",
        "Copyright (c) Express contributors"
    ],
    [
        "negotiator 0.6.3 (MIT)",
        "Copyright (c) Andrey Sitnik"
    ],
    [
        "nest-winston 1.10.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "nest-winston 1.10.2 (MIT)",
        "Copyright (c) 2018 Marco Polichetti"
    ],
    [
        "netmask 2.0.2 (MIT)",
        "Copyright (c) 2011 Olivier Poitrey <rs@rhapsodyk.net>"
    ],
    [
        "next-themes 0.4.6 (MIT)",
        "Copyright (c) 2022 Paco Coursey"
    ],
    [
        "node-addon-api 5.1.0 (MIT)",
        "Copyright (c) 2017 Node.js API collaborators"
    ],
    [
        "node-fetch 2.6.12 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "node-fetch 2.7.0 (MIT)",
        "Copyright (c) node-fetch contributors"
    ],
    [
        "node-fetch-native 1.6.7 (MIT)",
        "Copyright (c) node-fetch contributors"
    ],
    [
        "node-releases 2.0.19 (MIT)",
        "Copyright (c) 2017 Sergey Rubanov (<https://github.com/chicoxyzzy>)"
    ],
    [
        "nodemailer-fetch 1.6.0 (MIT)",
        "Copyright (c) Andris Reinman"
    ],
    [
        "nodemailer-shared 1.1.0 (MIT)",
        "Copyright (c) Andris Reinman"
    ],
    [
        "nodemailer-smtp-transport 2.7.4 (MIT)",
        "Copyright (c) Andris Reinman"
    ],
    [
        "nodemailer-wellknown 0.1.10 (MIT)",
        "Copyright (c) Andris Reinman"
    ],
    [
        "normalize-path 3.0.0 (MIT)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "normalize-range 0.1.2 (MIT)",
        "Copyright (c) Jon Schlinkert"
    ],
    [
        "nypm 0.6.2 (MIT)",
        "Copyright (c) npm, Inc. and Contributors"
    ],
    [
        "nypm 0.6.5 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "object-assign 4.1.1 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "object-hash 3.0.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "object-inspect 1.13.4 (MIT)",
        "Copyright (c) Jordan Harband"
    ],
    [
        "ohash 2.0.11 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io>"
    ],
    [
        "on-finished 2.3.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "on-finished 2.4.1 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "on-headers 1.0.2 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "on-headers 1.1.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "one-time 1.0.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "pac-proxy-agent 7.2.0 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "pac-resolver 7.0.1 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "pako 0.2.9 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "pako 1.0.11 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "pako 2.1.0 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "parent-module 1.0.1 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "parse-json 5.2.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "parseurl 1.3.3 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "path-is-absolute 1.0.1 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "path-to-regexp 0.1.12 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "path-to-regexp 0.2.5 (MIT)",
        "Copyright (c) Rich Harris"
    ],
    [
        "path-to-regexp 1.9.0 (MIT)",
        "Copyright (c) foliojs"
    ],
    [
        "path-to-regexp 3.3.0 (MIT)",
        "Copyright (c) bpampuch"
    ],
    [
        "pathe 2.0.3 (MIT)",
        "Copyright (c) Pooya Parsa <pooya@pi0.io> - Daniel Roe <daniel@roe.dev>"
    ],
    [
        "pdfkit 0.17.2 (MIT)",
        "Copyright (c) 2014 Devon Govett"
    ],
    [
        "pdfmake 0.3.6 (MIT)",
        "Copyright (c) 2014-2015 bpampuch 2016-2026 liborm85"
    ],
    [
        "pend 1.2.0 (MIT)",
        "2016-2026 liborm85"
    ],
    [
        "perfect-debounce 1.0.0 (MIT)",
        "Copyright (c) perfect-debounce contributors"
    ],
    [
        "performance-now 2.1.0 (MIT)",
        "Copyright (c) performance-now contributors"
    ],
    [
        "pg 8.13.3 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg 8.18.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-cloudflare 1.1.1 (MIT)",
        "Copyright (c) pg-cloudflare contributors"
    ],
    [
        "pg-cloudflare 1.3.0 (MIT)",
        "Copyright (c) pg-cloudflare contributors"
    ],
    [
        "pg-connection-string 2.11.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-connection-string 2.7.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-pool 3.11.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-pool 3.7.1 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-protocol 1.11.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-protocol 1.7.1 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pg-types 2.2.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "pgpass 1.0.5 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "picomatch 4.0.4 (MIT)",
        "Copyright (c) Jon Schlinkert"
    ],
    [
        "pkg-types 2.3.0 (MIT)",
        "Copyright (c) pkg-types contributors"
    ],
    [
        "postcss 8.5.6 (MIT)",
        "Copyright (c) Andrey Sitnik"
    ],
    [
        "postcss-value-parser 4.2.0 (MIT)",
        "Copyright (c) Andrey Sitnik"
    ],
    [
        "postgres-array 2.0.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "postgres-bytea 1.0.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "postgres-bytea 1.0.1 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "postgres-date 1.0.7 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "postgres-interval 1.2.0 (MIT)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "process-nextick-args 2.0.1 (MIT)",
        "Copyright (c) process-nextick-args contributors"
    ],
    [
        "progress 2.0.3 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "prop-types 15.8.1 (MIT)",
        "Copyright (c) Facebook, Inc."
    ],
    [
        "proxy-addr 2.0.7 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "proxy-agent 6.5.0 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "proxy-from-env 1.1.0 (MIT)",
        "Copyright (c) Rob W"
    ],
    [
        "pump 3.0.2 (MIT)",
        "Copyright (c) Mathias Buus"
    ],
    [
        "pure-rand 6.1.0 (MIT)",
        "Copyright (c) pure-rand contributors"
    ],
    [
        "raf 3.4.1 (MIT)",
        "Copyright (c) Dominic Tarr"
    ],
    [
        "range-parser 1.2.1 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "raw-body 2.5.2 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "raw-body 2.5.3 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "rc9 2.1.2 (MIT)",
        "Copyright (c) rc9 contributors"
    ],
    [
        "re-resizable 6.11.2 (MIT)",
        "Copyright (c) re-resizable contributors"
    ],
    [
        "react 18.3.1 (MIT)",
        "Copyright (c) Meta Platforms, Inc."
    ],
    [
        "react-day-picker 9.13.2 (MIT)",
        "Copyright (c) React Day Picker contributors"
    ],
    [
        "react-day-picker 9.9.0 (MIT)",
        "Copyright (c) React Day Picker contributors"
    ],
    [
        "react-dnd 16.0.1 (MIT)",
        "Copyright (c) React DnD contributors"
    ],
    [
        "react-dnd-html5-backend 16.0.1 (MIT)",
        "Copyright (c) React DnD contributors"
    ],
    [
        "react-dom 18.3.1 (MIT)",
        "Copyright (c) Meta Platforms, Inc."
    ],
    [
        "react-fast-compare 3.2.2 (MIT)",
        "Copyright (c) Formidable Labs"
    ],
    [
        "react-hook-form 7.55.0 (MIT)",
        "Copyright (c) React Hook Form contributors"
    ],
    [
        "react-is 16.13.1 (MIT)",
        "Copyright (c) Facebook, Inc."
    ],
    [
        "react-popper 2.3.0 (MIT)",
        "Copyright (c) Popper.js contributors"
    ],
    [
        "react-remove-scroll 2.7.1 (MIT)",
        "Copyright (c) react-remove-scroll contributors"
    ],
    [
        "react-remove-scroll 2.7.2 (MIT)",
        "Copyright (c) react-remove-scroll contributors"
    ],
    [
        "react-remove-scroll-bar 2.3.8 (MIT)",
        "Copyright (c) react-remove-scroll contributors"
    ],
    [
        "react-resizable-panels 3.0.4 (MIT)",
        "Copyright (c) react-resizable-panels contributors"
    ],
    [
        "react-resizable-panels 3.0.6 (MIT)",
        "Copyright (c) react-resizable-panels contributors"
    ],
    [
        "react-responsive-masonry 2.7.1 (MIT)",
        "Copyright (c) react-responsive-masonry contributors"
    ],
    [
        "react-router-dom 7.13.0 (MIT)",
        "Copyright (c) Remix Software Inc."
    ],
    [
        "react-router-dom 7.8.2 (MIT)",
        "Copyright (c) Remix Software Inc."
    ],
    [
        "react-slick 0.29.0 (MIT)",
        "Copyright (c) Neostack"
    ],
    [
        "react-style-singleton 2.2.3 (MIT)",
        "Copyright (c) react-style-singleton contributors"
    ],
    [
        "readable-stream 2.3.8 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "readable-stream 3.6.2 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "readdirp 4.1.2 (MIT)",
        "Copyright (c) Paul Miller"
    ],
    [
        "redux 4.2.1 (MIT)",
        "Copyright (c) Redux contributors"
    ],
    [
        "regenerator-runtime 0.13.11 (MIT)",
        "Copyright (c) Facebook, Inc."
    ],
    [
        "require-directory 2.1.1 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "resize-observer-polyfill 1.5.1 (MIT)",
        "Copyright (c) Que-etc"
    ],
    [
        "resolve-from 4.0.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "restructure 3.0.2 (MIT)",
        "Copyright (c) restructure contributors"
    ],
    [
        "rollup 4.46.3 (MIT)",
        "Copyright (c) Rollup contributors"
    ],
    [
        "rollup 4.60.0 (MIT)",
        "Copyright (c) Rollup contributors"
    ],
    [
        "safe-buffer 5.1.2 (MIT)",
        "Copyright (c) Feross Aboukhadijeh"
    ],
    [
        "safe-buffer 5.2.1 (MIT)",
        "Copyright (c) Feross Aboukhadijeh"
    ],
    [
        "safe-stable-stringify 2.4.3 (MIT)",
        "Copyright (c) BridgeAR"
    ],
    [
        "safe-stable-stringify 2.5.0 (MIT)",
        "Copyright (c) BridgeAR"
    ],
    [
        "safer-buffer 2.1.2 (MIT)",
        "Copyright (c) Feross Aboukhadijeh"
    ],
    [
        "scheduler 0.23.2 (MIT)",
        "Copyright (c) Meta Platforms, Inc."
    ],
    [
        "send 0.19.0 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "send 0.19.2 (MIT)",
        "Copyright (c) TJ Holowaychuk"
    ],
    [
        "serve-static 1.16.2 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "serve-static 1.16.3 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "set-cookie-parser 2.7.1 (MIT)",
        "Copyright (c) set-cookie-parser contributors"
    ],
    [
        "set-cookie-parser 2.7.2 (MIT)",
        "Copyright (c) set-cookie-parser contributors"
    ],
    [
        "setimmediate 1.0.5 (MIT)",
        "Copyright (c) YuzuJS contributors"
    ],
    [
        "side-channel 1.1.0 (MIT)",
        "Copyright (c) side-channel contributors"
    ],
    [
        "side-channel-list 1.0.0 (MIT)",
        "Copyright (c) side-channel contributors"
    ],
    [
        "side-channel-map 1.0.1 (MIT)",
        "Copyright (c) side-channel contributors"
    ],
    [
        "side-channel-weakmap 1.0.2 (MIT)",
        "Copyright (c) side-channel contributors"
    ],
    [
        "simple-swizzle 0.2.2 (MIT)",
        "Copyright (c) simple-swizzle contributors"
    ],
    [
        "smart-buffer 4.2.0 (MIT)",
        "Copyright (c) smart-buffer contributors"
    ],
    [
        "smtp-connection 2.12.0 (MIT)",
        "Copyright (c) Andris Reinman"
    ],
    [
        "socket.io 4.8.1 (MIT)",
        "Copyright (c) Guillermo Rauch"
    ],
    [
        "socket.io 4.8.3 (MIT)",
        "Copyright (c) Guillermo Rauch"
    ],
    [
        "socket.io-adapter 2.5.5 (MIT)",
        "Copyright (c) socket.io contributors"
    ],
    [
        "socket.io-adapter 2.5.6 (MIT)",
        "Copyright (c) socket.io contributors"
    ],
    [
        "socket.io-client 4.8.1 (MIT)",
        "Copyright (c) socket.io contributors"
    ],
    [
        "socket.io-client 4.8.3 (MIT)",
        "Copyright (c) socket.io contributors"
    ],
    [
        "socket.io-parser 4.2.4 (MIT)",
        "Copyright (c) socket.io contributors"
    ],
    [
        "socket.io-parser 4.2.6 (MIT)",
        "Copyright (c) socket.io contributors"
    ],
    [
        "socks 2.8.4 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "socks-proxy-agent 8.0.5 (MIT)",
        "Copyright (c) TooTallNate"
    ],
    [
        "sonner 2.0.3 (MIT)",
        "Copyright (c) sonner contributors"
    ],
    [
        "stack-trace 0.0.10 (MIT)",
        "Copyright (c) stack-trace contributors"
    ],
    [
        "stackblur-canvas 2.7.0 (MIT)",
        "Copyright (c) Mario Klingemann"
    ],
    [
        "statuses 2.0.1 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com> Copyright (c) 2016 Douglas Christopher Wilson <doug@somethingdoug.com>"
    ],
    [
        "statuses 2.0.2 (MIT)",
        "Copyright (c) 2014 Jonathan Ong <me@jongleberry.com> Copyright (c) 2016 Douglas Christopher Wilson <doug@somethingdoug.com>"
    ],
    [
        "streamsearch 1.1.0 (MIT)",
        "Copyright (c) Brian White"
    ],
    [
        "streamx 2.22.0 (MIT)",
        "Copyright (c) streamx contributors"
    ],
    [
        "string-convert 0.2.1 (MIT)",
        "Copyright (c) string-convert contributors"
    ],
    [
        "string-width 4.2.3 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "string_decoder 1.1.1 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "string_decoder 1.3.0 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "strip-ansi 6.0.1 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "stripe 18.5.0 (MIT)",
        "Copyright (c) Stripe, Inc."
    ],
    [
        "supports-color 7.2.0 (MIT)",
        "Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)"
    ],
    [
        "svg-pathdata 6.0.3 (MIT)",
        "Copyright © 2017 Nicolas Froidure"
    ],
    [
        "tailwind-merge 2.6.0 (MIT)",
        "Copyright (c) 2021 Dany Castillo"
    ],
    [
        "tailwind-merge 2.6.1 (MIT)",
        "Copyright (c) 2021 Dany Castillo"
    ],
    [
        "tailwindcss 4.1.12 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "tailwindcss 4.1.18 (MIT)",
        "Copyright (c) Tailwind Labs, Inc."
    ],
    [
        "tapable 2.2.2 (MIT)",
        "Copyright (c) Tobias Koppers"
    ],
    [
        "tapable 2.3.0 (MIT)",
        "Copyright (c) Tobias Koppers"
    ],
    [
        "tar-fs 3.0.8 (MIT)",
        "Copyright (c) 2013 mafintosh"
    ],
    [
        "tar-stream 2.2.0 (MIT)",
        "Copyright (c) 2014 mafintosh"
    ],
    [
        "tar-stream 3.1.7 (MIT)",
        "Copyright (c) 2014 mafintosh"
    ],
    [
        "text-hex 1.0.0 (MIT)",
        "Copyright (c) 2014-2015 Arnout Kazemier <opensource@3rd-Eden.com>"
    ],
    [
        "text-segmentation 1.0.3 (MIT)",
        "Copyright (c) 2021 Niklas von Hertzen"
    ],
    [
        "through 2.3.8 (MIT)",
        "Copyright (c) 2013 Dominic Tarr"
    ],
    [
        "tiny-inflate 1.0.3 (MIT)",
        "Copyright (c) 2014 imaya"
    ],
    [
        "tinyexec 1.0.1 (MIT)",
        "Copyright (c) 2024 Tinylibs"
    ],
    [
        "tinyexec 1.0.2 (MIT)",
        "Copyright (c) 2024 Tinylibs"
    ],
    [
        "tinyglobby 0.2.15 (MIT)",
        "Copyright (c) antfu"
    ],
    [
        "tmp 0.2.1 (MIT)",
        "Copyright (c) 2011 Joyent, Inc."
    ],
    [
        "tmp 0.2.5 (MIT)",
        "Copyright (c) 2011 Joyent, Inc."
    ],
    [
        "toidentifier 1.0.1 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "tr46 0.0.3 (MIT)",
        "Copyright (c) 2014 The Chromium Authors"
    ],
    [
        "transliteration 2.3.5 (MIT)",
        "Copyright <http://github.com/dzcpy/transliteration>"
    ],
    [
        "transliteration 2.6.1 (MIT)",
        "Copyright <http://github.com/dzcpy/transliteration>"
    ],
    [
        "traverse 0.3.9 (MIT)",
        "Copyright (c) 2011 James Halliday"
    ],
    [
        "triple-beam 1.4.1 (MIT)",
        "Copyright (c) 2014 winston contributors"
    ],
    [
        "type-is 1.6.18 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "typedarray 0.0.6 (MIT)",
        "Copyright (c) 2013-2015 Feross Aboukhadijeh"
    ],
    [
        "uid 2.0.2 (MIT)",
        "Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)"
    ],
    [
        "uint8array-extras 1.5.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "unbzip2-stream 1.4.3 (MIT)",
        "Copyright (c) 2014 Tim Koschützki"
    ],
    [
        "underscore 1.7.0 (MIT)",
        "Copyright (c) Jeremy Ashkenas"
    ],
    [
        "undici-types 5.26.5 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "undici-types 6.21.0 (MIT)",
        "Copyright (c) Node.js contributors"
    ],
    [
        "unicode-properties 1.4.1 (MIT)",
        "Copyright 2018"
    ],
    [
        "unicode-trie 2.0.0 (MIT)",
        "Copyright 2018"
    ],
    [
        "unpipe 1.0.0 (MIT)",
        "Copyright (c) Douglas Christopher Wilson"
    ],
    [
        "unzipper 0.10.14 (MIT)",
        "Copyright (c) 2012 - 2013 Near Infinity Corporation"
    ],
    [
        "update-browserslist-db 1.1.3 (MIT)",
        "Copyright 2022 Andrey Sitnik <andrey@sitnik.ru> and other contributors"
    ],
    [
        "urlpattern-polyfill 10.0.0 (MIT)",
        "Copyright 2020 Intel Corporation"
    ],
    [
        "use-callback-ref 1.3.3 (MIT)",
        "Copyright (c) 2017 Anton Korzunov"
    ],
    [
        "use-sidecar 1.1.3 (MIT)",
        "Copyright (c) 2017 Anton Korzunov"
    ],
    [
        "use-sync-external-store 1.5.0 (MIT)",
        "Copyright (c) Meta Platforms, Inc. and affiliates."
    ],
    [
        "use-sync-external-store 1.6.0 (MIT)",
        "Copyright (c) Meta Platforms, Inc. and affiliates."
    ],
    [
        "util-deprecate 1.0.2 (MIT)",
        "Copyright (c) 2013 Nathan Rajlich"
    ],
    [
        "utils-merge 1.0.1 (MIT)",
        "Copyright (c) 2014 Jonathan Ong"
    ],
    [
        "utrie 1.0.2 (MIT)",
        "Copyright (c) 2021 Niklas von Hertzen"
    ],
    [
        "uuid 10.0.0 (MIT)",
        "Copyright (c) 2010-2020 Robert Kieffer and other contributors"
    ],
    [
        "uuid 11.0.3 (MIT)",
        "Copyright (c) 2010-2024 uuid contributors"
    ],
    [
        "uuid 8.3.2 (MIT)",
        "Copyright (c) 2010-2020 Robert Kieffer and other contributors"
    ],
    [
        "uuid 9.0.1 (MIT)",
        "Copyright (c) 2010-2022 uuid contributors"
    ],
    [
        "validator 13.15.26 (MIT)",
        "Copyright (c) 2018-2024 validator.js contributors"
    ],
    [
        "validator 13.9.0 (MIT)",
        "Copyright (c) 2018-2022 validator.js contributors"
    ],
    [
        "vary 1.1.2 (MIT)",
        "Copyright (c) 2014-2017 Douglas Christopher Wilson"
    ],
    [
        "vaul 0.7.9 (MIT)",
        "Copyright (c) 2023 Emil Kowalski"
    ],
    [
        "vite 5.4.19 (MIT)",
        "Copyright (c) Evan You and Vite contributors"
    ],
    [
        "vite 6.4.1 (MIT)",
        "Copyright (c) Evan You and Vite contributors"
    ],
    [
        "warning 4.0.3 (MIT)",
        "Copyright (c) 2014-2017 Facebook, Inc."
    ],
    [
        "whatwg-url 5.0.0 (MIT)",
        "Copyright (c) 2014 WHATWG contributors"
    ],
    [
        "winston 3.13.0 (MIT)",
        "Copyright (c) 2010 Charlie Robbins"
    ],
    [
        "winston 3.19.0 (MIT)",
        "Copyright (c) 2010 Charlie Robbins"
    ],
    [
        "winston-transport 4.7.0 (MIT)",
        "Copyright (c) 2013-2024 winston contributors"
    ],
    [
        "winston-transport 4.9.0 (MIT)",
        "Copyright (c) 2013-2024 winston contributors"
    ],
    [
        "wrap-ansi 7.0.0 (MIT)",
        "Copyright (c) Sindre Sorhus"
    ],
    [
        "ws 8.17.1 (MIT)",
        "Copyright (c) 2011 Einar Otto Stangvik"
    ],
    [
        "ws 8.18.1 (MIT)",
        "Copyright (c) 2011 Einar Otto Stangvik"
    ],
    [
        "ws 8.18.3 (MIT)",
        "Copyright (c) 2011 Einar Otto Stangvik"
    ],
    [
        "xmlchars 2.2.0 (MIT)",
        "Copyright (c) 2017 Sebastian Mayr"
    ],
    [
        "xmldoc 2.0.3 (MIT)",
        "Copyright (c) 2012-2015 Jiri Vobornik"
    ],
    [
        "xmlhttprequest-ssl 2.1.2 (MIT)",
        "Copyright (c) 2012-2015 driverdan"
    ],
    [
        "xtend 4.0.2 (MIT)",
        "Copyright (c) Raynos"
    ],
    [
        "yargs 17.7.2 (MIT)",
        "Copyright (c) 2010 James Halliday"
    ],
    [
        "yauzl 2.10.0 (MIT)",
        "Copyright (c) 2014-2018 Josh Wolfe"
    ],
    [
        "yauzl 3.1.2 (MIT)",
        "Copyright (c) 2014-2023 Josh Wolfe"
    ],
    [
        "yauzl 3.2.1 (MIT)",
        "Copyright (c) 2014-2024 Josh Wolfe"
    ],
    [
        "yazl 2.5.1 (MIT)",
        "Copyright (c) 2014-2020 Josh Wolfe"
    ],
    [
        "yazl 3.3.1 (MIT)",
        "Copyright (c) 2014-2024 Josh Wolfe"
    ],
    [
        "zip-lib 1.0.3 (MIT)",
        "Copyright (c) 2019 Ouga"
    ],
    [
        "zip-lib 1.2.1 (MIT)",
        "Copyright (c) 2019 Ouga"
    ],
    [
        "zip-stream 4.1.0 (MIT)",
        "Copyright (c) 2014-2018 archiver contributors"
    ],
    [
        "zip-stream 4.1.1 (MIT)",
        "Copyright (c) 2014-2018 archiver contributors"
    ],
    [
        "zod 3.23.8 (MIT)",
        "Copyright (c) 2020 Colin McDonnell"
    ]
];

const APACHE_LICENSE_LIST = [
    [
        "gcp-metadata 6.1.0 (Apache-2.0)",
        "Copyright 2022 Google LLC"
    ],
    [
        "google-auth-library 9.4.1 (Apache-2.0)",
        "Copyright 2019 Google LLC"
    ],
    [
        "googleapis 130.0.0 (Apache-2.0)",
        "Copyright 2020 Google LLC"
    ],
    [
        "googleapis-common 7.0.1 (Apache-2.0)",
        "Copyright 2022 Google LLC"
    ],
    [
        "prisma 6.16.1 (Apache-2.0)",
        "Copyright (c) Prisma Labs"
    ],
    [
        "prisma 6.19.2 (Apache-2.0)",
        "Copyright (c) Prisma Labs"
    ],
    [
        "puppeteer 22.15.0 (Apache-2.0)",
        "Copyright (c) Google Inc."
    ],
    [
        "puppeteer-core 22.15.0 (Apache-2.0)",
        "Copyright (c) Google Inc."
    ],
    [
        "react-router 7.13.0 (Apache-2.0)",
        "Copyright (c) Remix Software Inc."
    ],
    [
        "react-router 7.8.2 (Apache-2.0)",
        "Copyright (c) Remix Software Inc."
    ],
    [
        "readdir-glob 1.1.3 (Apache-2.0)",
        "Copyright (c) readdir-glob contributors"
    ],
    [
        "reflect-metadata 0.1.14 (Apache-2.0)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "reflect-metadata 0.2.2 (Apache-2.0)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "rxjs 7.8.1 (Apache-2.0)",
        "Copyright (c) ReactiveX contributors"
    ],
    [
        "rxjs 7.8.2 (Apache-2.0)",
        "Copyright (c) ReactiveX contributors"
    ],
    [
        "swagger-ui-dist 5.17.14 (Apache-2.0)",
        "Copyright 2020-2021 SmartBear Software Inc."
    ],
    [
        "text-decoder 1.2.3 (Apache-2.0)",
        "Copyright 2023 Holepunch Inc"
    ],
    [
        "typescript 5.7.2 (Apache-2.0)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "typescript 5.9.3 (Apache-2.0)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "@prisma/client 6.16.1 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/client 6.19.2 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/config 6.16.1 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/config 6.19.2 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/debug 6.16.1 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/debug 6.19.2 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/engines 6.16.1 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/engines 6.19.2 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/fetch-engine 6.16.1 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/fetch-engine 6.19.2 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/get-platform 6.16.1 (Apache-2.0)",
        ""
    ],
    [
        "@prisma/get-platform 6.19.2 (Apache-2.0)",
        ""
    ],
    [
        "@puppeteer/browsers 2.3.0 (Apache-2.0)",
        "Copyright 2017 Google Inc."
    ],
    [
        "@swc/helpers 0.5.17 (Apache-2.0)",
        "Copyright 2024 SWC contributors."
    ],
    [
        "@swc/helpers 0.5.19 (Apache-2.0)",
        "Copyright 2024 SWC contributors."
    ],
    [
        "b4a 1.6.7 (Apache-2.0)",
        "Copyright 2023 Holepunch Inc"
    ],
    [
        "bare-events 2.5.4 (Apache-2.0)",
        "Copyright 2023 Holepunch Inc"
    ],
    [
        "bare-fs 4.0.1 (Apache-2.0)",
        "Copyright 2023 Holepunch Inc"
    ],
    [
        "bare-os 3.5.1 (Apache-2.0)",
        "Copyright 2023 Holepunch Inc"
    ],
    [
        "bare-path 3.0.0 (Apache-2.0)",
        "Copyright 2023 Holepunch Inc"
    ],
    [
        "bare-stream 2.6.5 (Apache-2.0)",
        "Copyright 2024 Holepunch Inc"
    ],
    [
        "before-after-hook 4.0.0 (Apache-2.0)",
        "Copyright 2018 Gregor Martynus and other contributors."
    ],
    [
        "chromium-bidi 0.6.3 (Apache-2.0)",
        ""
    ],
    [
        "class-validator 0.14.3 (Apache-2.0)",
        "Copyright (c) 2015-2020 TypeStack"
    ],
    [
        "class-variance-authority 0.7.1 (Apache-2.0)",
        "Copyright 2022 Joe Bell"
    ],
    [
        "crc-32 1.2.2 (Apache-2.0)",
        "Copyright (C) 2014-present SheetJS LLC"
    ],
    [
        "detect-libc 2.0.2 (Apache-2.0)",
        "Copyright 2017 Lovell Fuller and others."
    ],
    [
        "detect-libc 2.0.4 (Apache-2.0)",
        "Copyright 2017 Lovell Fuller and others."
    ],
    [
        "detect-libc 2.1.2 (Apache-2.0)",
        "Copyright 2017 Lovell Fuller and others."
    ],
    [
        "dompurify 3.2.6 (Apache-2.0)",
        "Copyright 2025 Dr.-Ing. Mario Heiderich, Cure53"
    ],
    [
        "ecdsa-sig-formatter 1.0.11 (Apache-2.0)",
        "Copyright 2015 D2L Corporation"
    ],
    [
        "echarts 5.6.0 (Apache-2.0)",
        "Copyright 2017-2024 The Apache Software Foundation"
    ],
    [
        "gaxios 6.1.1 (Apache-2.0)",
        "Copyright 2023 Google LLC"
    ]
];

const BSD_LICENSE_LIST = [
    [
        "@mapbox/node-pre-gyp 1.0.11 (BSD-3-Clause)",
        "Copyright (c), Mapbox"
    ],
    [
        "bcryptjs 3.0.2 (BSD-3-Clause)",
        "Copyright (c) 2025 Daniel Wirtz <dcode@dcode.io>"
    ],
    [
        "buffer-equal-constant-time 1.0.1 (BSD-3-Clause)",
        "Copyright (c) 2013, GoInstant Inc., a salesforce.com company All rights reserved."
    ],
    [
        "d3 8.3.1 (BSD-3-Clause)",
        "Copyright 2010-2023 Mike Bostock"
    ],
    [
        "deepmerge-ts 7.1.5 (BSD-3-Clause)",
        "Copyright (c) 2021, Rebecca Stevens All rights reserved."
    ],
    [
        "devtools-protocol 0.0.1312386 (BSD-3-Clause)",
        "Copyright 2014 The Chromium Authors. All rights reserved."
    ],
    [
        "dotenv 16.6.1 (BSD-3-Clause)",
        "Copyright (c) 2015, Scott Motte All rights reserved."
    ],
    [
        "duplexer2 0.1.4 (BSD-3-Clause)",
        "Copyright (c) 2013, Deoxxa Development"
    ],
    [
        "escodegen 2.1.0 (BSD-2-Clause)",
        "Copyright (C) 2012 Yusuke Suzuki (twitter: @Constellation) and other contributors."
    ],
    [
        "esprima 4.0.1 (BSD-2-Clause)",
        "Copyright JS Foundation and other contributors, <https://js.foundation/>"
    ],
    [
        "estraverse 5.3.0 (BSD-2-Clause)",
        "Copyright (C) 2012-2016 \\[Yusuke Suzuki\\](<http://github.com/Constellation>) (twitter: \\[@Constellation\\](<http://twitter.com/Constellation>)) and other contributors."
    ],
    [
        "esutils 2.0.3 (BSD-2-Clause)",
        "Copyright (C) 2013 \\[Yusuke Suzuki\\](<http://github.com/Constellation>) (twitter: \\[@Constellation\\](<http://twitter.com/Constellation>)) and other contributors."
    ],
    [
        "extract-zip 2.0.1 (BSD-2-Clause)",
        "Copyright (c) 2014 Max Ogden and other contributors All rights reserved."
    ],
    [
        "follow-redirects 1.15.11 (BSD-3-Clause)",
        "Copyright 2014-present Olivier Lalonde <olalonde@gmail.com>, James Talmage <james@talmage.io>, Ruben Verborgh"
    ],
    [
        "hoist-non-react-statics 3.3.2 (BSD-3-Clause)",
        "Copyright (c) 2015 Yahoo! Inc."
    ],
    [
        "ieee754 1.2.1 (BSD-3-Clause)",
        "Copyright (c) 2014 Feross Aboukhadijeh"
    ],
    [
        "qs 6.13.0 (BSD-3-Clause)",
        "Copyright (c) LJ Harb"
    ],
    [
        "qs 6.14.2 (BSD-3-Clause)",
        "Copyright (c) LJ Harb"
    ],
    [
        "sax 1.5.0 (BSD-3-Clause)",
        "Copyright (c) Isaac Z. Schlueter"
    ],
    [
        "semver 7.7.4 (BSD-3-Clause)",
        "Copyright (c) npm, Inc."
    ],
    [
        "source-map 0.6.1 (BSD-3-Clause)",
        "Copyright (c) Mozilla Foundation"
    ],
    [
        "source-map-js 1.2.1 (BSD-3-Clause)",
        "Copyright (c) Mozilla Foundation"
    ],
    [
        "sprintf-js 1.1.3 (BSD-3-Clause)",
        "Copyright (c) Alexandru Marasteanu"
    ],
    [
        "strtok3 10.3.4 (BSD-3-Clause)",
        "Copyright © 2025 Borewit"
    ],
    [
        "tar 7.5.13 (BSD-3-Clause)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "token-types 6.1.2 (BSD-3-Clause)",
        "Copyright (c) 2020 BendingBender"
    ],
    [
        "tslib 2.3.0 (BSD-3-Clause)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "tslib 2.6.2 (BSD-3-Clause)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "tslib 2.8.1 (BSD-3-Clause)",
        "Copyright (c) Microsoft Corporation"
    ],
    [
        "url-template 2.0.8 (BSD-3-Clause)",
        "Copyright (c) 2015 Roman Shtylman"
    ],
    [
        "webidl-conversions 3.0.1 (BSD-2-Clause)",
        "Copyright (c) 2014 Domenic Denicola"
    ],
    [
        "zrender 5.6.1 (BSD-3-Clause)",
        "Copyright (c) 2013, Baidu Inc."
    ]
];

const ISC_LICENSE_LIST = [
    [
        "@isaacs/fs-minipass 4.0.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "abbrev 1.1.1 (ISC)",
        "Copyright Isaac Z. Schlueter and Contributors"
    ],
    [
        "aproba 2.0.0 (ISC)",
        "Copyright (c) 2015, Rebecca Turner <me@re-becca.org>"
    ],
    [
        "aproba 2.1.0 (ISC)",
        "Copyright (c) 2015, Rebecca Turner <me@re-becca.org>"
    ],
    [
        "are-we-there-yet 2.0.0 (ISC)",
        "Copyright npm, Inc."
    ],
    [
        "call-bound 1.0.4 (ISC)",
        "Copyright (c) 2024 Jordan Harband"
    ],
    [
        "chownr 2.0.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "cliui 8.0.1 (ISC)",
        "Copyright (c) 2015, Contributors"
    ],
    [
        "color-support 1.1.3 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "console-control-strings 1.1.0 (ISC)",
        "Copyright (c) 2014, Rebecca Turner <me@re-becca.org>"
    ],
    [
        "electron-to-chromium 1.5.206 (ISC)",
        "Copyright 2018 Kilian Valkhof"
    ],
    [
        "fs-minipass 2.1.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "fs.realpath 1.0.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "fstream 1.0.12 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "gauge 3.0.2 (ISC)",
        "Copyright (c) 2014, Rebecca Turner <me@re-becca.org>"
    ],
    [
        "get-caller-file 2.0.5 (ISC)",
        "Copyright 2018 Stefan Penner"
    ],
    [
        "glob 7.2.3 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "graceful-fs 4.2.11 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "has-unicode 2.0.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "inflight 1.0.6 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "inherits 2.0.4 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "iterare 1.2.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "listenercount 1.0.1 (ISC)",
        "Copyright (c) Parcel contributors"
    ],
    [
        "lru-cache 7.18.3 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "lucide-react 0.294.0 (ISC)",
        "Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2022 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2022."
    ],
    [
        "minimatch 3.1.2 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minimatch 5.1.6 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minipass 3.3.6 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minipass 5.0.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "minipass 7.1.2 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "nopt 5.0.0 (ISC)",
        "Copyright (c) Andris Reinman"
    ],
    [
        "npmlog 5.0.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "once 1.4.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "pg-int8 1.0.1 (ISC)",
        "Copyright (c) Brian Carlson"
    ],
    [
        "picocolors 1.1.1 (ISC)",
        "Copyright (c) Alexey Kuznetsov"
    ],
    [
        "rimraf 2.7.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter"
    ],
    [
        "rimraf 3.0.2 (ISC)",
        "Copyright (c) Isaac Z. Schlueter"
    ],
    [
        "saxes 5.0.1 (ISC)",
        "Copyright (c) Tim Bray"
    ],
    [
        "semver 6.3.1 (ISC)",
        "Copyright (c) npm, Inc."
    ],
    [
        "semver 7.7.1 (ISC)",
        "Copyright (c) npm, Inc."
    ],
    [
        "set-blocking 2.0.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter"
    ],
    [
        "setprototypeof 1.2.0 (ISC)",
        "Copyright (c) setprototypeof contributors"
    ],
    [
        "signal-exit 3.0.7 (ISC)",
        "Copyright (c) Isaac Z. Schlueter"
    ],
    [
        "split2 4.2.0 (ISC)",
        "Copyright (c) Matteo Collina"
    ],
    [
        "tar 6.2.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "tar 7.4.3 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "universal-user-agent 7.0.3 (ISC)",
        "Copyright (c) Octokit contributors"
    ],
    [
        "wide-align 1.1.5 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "wrappy 1.0.2 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "y18n 5.0.8 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "yallist 4.0.0 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ],
    [
        "yargs-parser 21.1.1 (ISC)",
        "Copyright (c) Isaac Z. Schlueter and Contributors"
    ]
];

const MPL2_LICENSE_LIST = [
    [
        "lightningcss 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-darwin-arm64 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-darwin-arm64 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-darwin-x64 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-darwin-x64 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-freebsd-x64 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-freebsd-x64 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-arm-gnueabihf 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-arm-gnueabihf 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-arm64-gnu 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-arm64-gnu 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-arm64-musl 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-arm64-musl 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-x64-gnu 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-x64-gnu 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-x64-musl 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-linux-x64-musl 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-win32-arm64-msvc 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-win32-arm64-msvc 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-win32-x64-msvc 1.30.1 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ],
    [
        "lightningcss-win32-x64-msvc 1.30.2 (MPL-2.0)",
        "Copyright © 2024 Devon Govett and Parcel Contributors."
    ]
];
export default function ThirdPartyLicenseObligation() {
    return (
        <div className="min-h-screen bg-background px-4 py-12 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-6xl rounded-lg border bg-card p-8 shadow">
                <h1 className="text-3xl font-bold text-foreground mb-2 text-center">Orbit8 Application Third-party component List</h1>

                <div className="space-y-6 text-foreground/80  mt-4">
                    <h2 className=" font-bold text-foreground mb-2">Components Licensed Under the MIT License</h2>

                    <div className="overflow-x-auto rounded-lg border">
                        <table className="min-w-full divide-y divide-border text-sm">

                            <tbody className="divide-y divide-border">
                                {MIT_LICENSE_LIST.map((row, rowIndex) => (
                                    <tr key={rowIndex} className="align-top">
                                        {row.map((cell, cellIndex) => (
                                            <td key={cellIndex} className="px-4 py-3">
                                                {cell}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="space-y-6 text-foreground/80 mt-8">
                    <h2 className="font-bold text-foreground mb-4">MIT License:</h2>

                    <div className="rounded-lg border bg-muted/50 p-6">
                        <pre className="text-sm leading-relaxed whitespace-pre-wrap font-mono">
                            {`Copyright <YEAR> <COPYRIGHT HOLDER>

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}
                        </pre>
                    </div>
                </div>



                <div className="space-y-6 text-foreground/80  mt-4">
                    <h2 className=" font-bold text-foreground mb-2">Components Licensed Under The Apache License, Version 2.0</h2>

                    <div className="overflow-x-auto rounded-lg border">
                        <table className="min-w-full divide-y divide-border text-sm">

                            <tbody className="divide-y divide-border">
                                {APACHE_LICENSE_LIST.map((row, rowIndex) => (
                                    <tr key={rowIndex} className="align-top">
                                        {row.map((cell, cellIndex) => (
                                            <td key={cellIndex} className="px-4 py-3">
                                                {cell}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="space-y-6 text-foreground/80 mt-8">
                    <h2 className="font-bold text-foreground mb-4">The Apache License, Version 2.0</h2>

                    <div className="rounded-lg border bg-muted/50 p-6 space-y-4">
                        <div className="text-center font-bold text-lg mb-4">
                            TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION
                        </div>

                        <div className="space-y-4">
                            <div>
                                <h3 className="font-semibold mb-2">1. Definitions.</h3>
                                <div className="space-y-2 text-sm leading-relaxed">
                                    <p><strong>"License"</strong> shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document.</p>
                                    <p><strong>"Licensor"</strong> shall mean the copyright owner or entity authorized by the copyright owner that is granting the License.</p>
                                    <p><strong>"Legal Entity"</strong> shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, "control" means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity.</p>
                                    <p><strong>"You"</strong> (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this License.</p>
                                    <p><strong>"Source"</strong> form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files.</p>
                                    <p><strong>"Object"</strong> form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types.</p>
                                    <p><strong>"Work"</strong> shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below).</p>
                                    <p><strong>"Derivative Works"</strong> shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof.</p>
                                    <p><strong>"Contribution"</strong> shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as "Not a Contribution."</p>
                                    <p><strong>"Contributor"</strong> shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work.</p>
                                </div>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">2. Grant of Copyright License.</h3>
                                <p className="text-sm leading-relaxed">Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">3. Grant of Patent License.</h3>
                                <p className="text-sm leading-relaxed">Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">4. Redistribution.</h3>
                                <p className="text-sm leading-relaxed mb-2">You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions:</p>
                                <div className="ml-4 space-y-1 text-sm">
                                    <p>(a) You must give any other recipients of the Work or Derivative Works a copy of this License; and</p>
                                    <p>(b) You must cause any modified files to carry prominent notices stating that You changed the files; and</p>
                                    <p>(c) You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and</p>
                                    <p>(d) If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License.</p>
                                </div>
                                <p className="text-sm leading-relaxed mt-2">You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">5. Submission of Contributions.</h3>
                                <p className="text-sm leading-relaxed">Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">6. Trademarks.</h3>
                                <p className="text-sm leading-relaxed">This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">7. Disclaimer of Warranty.</h3>
                                <p className="text-sm leading-relaxed">Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">8. Limitation of Liability.</h3>
                                <p className="text-sm leading-relaxed">In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages.</p>
                            </div>

                            <div>
                                <h3 className="font-semibold mb-2">9. Accepting Warranty or Additional Liability.</h3>
                                <p className="text-sm leading-relaxed">While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability.</p>
                            </div>

                            <div className="border-t pt-4 mt-6">
                                <h3 className="font-bold text-center mb-4">END OF TERMS AND CONDITIONS</h3>

                                <div className="mt-6">
                                    <h4 className="font-semibold mb-2">APPENDIX: How to apply the Apache License to your work.</h4>
                                    <p className="text-sm leading-relaxed mb-4">To apply the Apache License to your work, attach the following boilerplate notice, with the fields enclosed by brackets "[]" replaced with your own identifying information. (Don't include the brackets!) The text should be enclosed in the appropriate comment syntax for the file format. We also recommend that a file or class name and description of purpose be included on the same "printed page" as the copyright notice for easier identification within third-party archives.</p>

                                    <div className="bg-muted/30 p-4 rounded text-sm font-mono leading-relaxed border-l-4 border-primary/20">
                                        <div>Copyright [yyyy] [name of copyright owner]</div>
                                        <div className="mt-2">Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at</div>
                                        <div className="mt-1">http://www.apache.org/licenses/LICENSE-2.0</div>
                                        <div className="mt-2">Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="space-y-6 text-foreground/80  mt-4">
                    <h2 className=" font-bold text-foreground mb-2">Components Licensed Under The BSD License</h2>

                    <div className="overflow-x-auto rounded-lg border">
                        <table className="min-w-full divide-y divide-border text-sm">

                            <tbody className="divide-y divide-border">
                                {BSD_LICENSE_LIST.map((row, rowIndex) => (
                                    <tr key={rowIndex} className="align-top">
                                        {row.map((cell, cellIndex) => (
                                            <td key={cellIndex} className="px-4 py-3">
                                                {cell}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="space-y-6 text-foreground/80 mt-8">
                    <h2 className="font-bold text-foreground mb-4">License text for BSD-2-Clause License</h2>

                    <div className="rounded-lg border bg-muted/50 p-6 space-y-6">
                        <div>
                            <h3 className="font-semibold text-lg mb-4">BSD-2-Clause License</h3>
                            <p className="text-sm leading-relaxed mb-4">
                                Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
                            </p>

                            <div className="ml-4 space-y-2 text-sm leading-relaxed mb-4">
                                <p>1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.</p>
                                <p>2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.</p>
                            </div>

                            <div className="bg-muted/30 p-4 rounded text-sm leading-relaxed border-l-4 border-primary/20">
                                <p className="font-medium mb-2">Disclaimer:</p>
                                <p>
                                    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                </p>
                            </div>
                        </div>

                        <div className="border-t pt-6">
                            <h3 className="font-semibold text-lg mb-4">BSD-3-Clause License</h3>
                            <p className="text-sm leading-relaxed mb-4">
                                Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
                            </p>

                            <div className="ml-4 space-y-2 text-sm leading-relaxed mb-4">
                                <p>1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.</p>
                                <p>2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.</p>
                                <p>3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.</p>
                            </div>

                            <div className="bg-muted/30 p-4 rounded text-sm leading-relaxed border-l-4 border-primary/20">

                                <p>
                                    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="space-y-6 text-foreground/80 mt-8">
                    <h2 className="font-bold text-foreground mb-2">Components Under Unlicense</h2>

                    <div className="overflow-x-auto rounded-lg border">
                        <table className="min-w-full divide-y divide-border text-sm">
                            <tbody className="divide-y divide-border">
                                <tr className="align-top">
                                    <td className="px-4 py-3">big-integer 1.6.51 (Unlicense)</td>
                                </tr>
                                <tr className="align-top">
                                    <td className="px-4 py-3">big-integer 1.6.52 (Unlicense)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="space-y-6 text-foreground/80 mt-8">
                    <h2 className="font-bold text-foreground mb-4">Unlicense Text</h2>

                    <div className="rounded-lg border bg-muted/50 p-6 space-y-4">
                        <div className="space-y-3 text-sm leading-relaxed">
                            <p>This is free and unencumbered software released into the public domain.</p>

                            <p>Anyone is free to copy, modify, publish, use, compile, sell, or distribute this software, either in source code form or as a compiled binary, for any purpose, commercial or non-commercial, and by any means.</p>

                            <p>In jurisdictions that recognize copyright laws, the author or authors of this software dedicate any and all copyright interest in the software to the public domain. We make this dedication for the benefit of the public at large and to the detriment of our heirs and successors. We intend this dedication to be an overt act of relinquishment in perpetuity of all present and future rights to this software under copyright law.</p>
                        </div>

                        <div className="bg-muted/30 p-4 rounded text-sm leading-relaxed border-l-4 border-primary/20">

                            <p>
                                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                            </p>
                        </div>
                    </div>
                </div>




                <div className="space-y-6 text-foreground/80  mt-4">
                    <h2 className=" font-bold text-foreground mb-2">Components under ISC License:</h2>

                    <div className="overflow-x-auto rounded-lg border">
                        <table className="min-w-full divide-y divide-border text-sm">

                            <tbody className="divide-y divide-border">
                                {ISC_LICENSE_LIST.map((row, rowIndex) => (
                                    <tr key={rowIndex} className="align-top">
                                        {row.map((cell, cellIndex) => (
                                            <td key={cellIndex} className="px-4 py-3">
                                                {cell}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="space-y-6 text-foreground/80 mt-8">
                    <h2 className="font-bold text-foreground mb-4">License Text for Unlicense</h2>

                    <div className="rounded-lg border bg-muted/50 p-6 space-y-4">
                        <div className="space-y-3 text-sm leading-relaxed">
                            <p>Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.</p>
                        </div>

                        <div className="bg-muted/30 p-4 rounded text-sm leading-relaxed border-l-4 border-primary/20">

                            <p>
                                THE SOFTWARE IS PROVIDED “AS IS” AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
                            </p>
                        </div>

                        <div className="space-y-6 text-foreground/80 mt-8">
                            <h2 className="font-bold text-foreground mb-2">Components Under CC-BY-4.0</h2>

                            <div className="overflow-x-auto rounded-lg border">
                                <table className="min-w-full divide-y divide-border text-sm">
                                    <tbody className="divide-y divide-border">
                                        <tr className="align-top">
                                            <td className="px-4 py-3">caniuse-lite 1.0.30001735 (CC-BY-4.0)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="space-y-6 text-foreground/80 mt-8">
                            <h2 className="font-bold text-foreground mb-2">License text for CC-BY-4.0</h2>

                            <div className="overflow-x-auto rounded-lg border">
                                <table className="min-w-full divide-y divide-border text-sm">
                                    <tbody className="divide-y divide-border">
                                        <tr className="align-top">
                                            <td className="px-4 py-3">Creative Commons Attribution 4.0 International</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="space-y-6 text-foreground/80 mt-8">

                            <div className="rounded-lg border bg-muted/50 p-6 space-y-6">
                                <div>
                                    <div className="space-y-3 text-sm leading-relaxed">
                                        <p>Creative Commons Corporation ("Creative Commons") is not a law firm and does not provide legal services or legal advice. Distribution of Creative Commons public licenses does not create a lawyer-client or other relationship. Creative Commons makes its licenses and related information available on an "as-is" basis. Creative Commons gives no warranties regarding its licenses, any material licensed under their terms and conditions, or any related information. Creative Commons disclaims all liability for damages resulting from their use to the fullest extent possible.</p>
                                    </div>
                                </div>

                                <div className="border-t pt-4">
                                    <h4 className="font-semibold mb-3">Using Creative Commons Public Licenses</h4>
                                    <div className="space-y-3 text-sm leading-relaxed">
                                        <p>Creative Commons public licenses provide a standard set of terms and conditions that creators and other rights holders may use to share original works of authorship and other material subject to copyright and certain other rights specified in the public license below. The following considerations are for informational purposes only, are not exhaustive, and do not form part of our licenses.</p>

                                        <p><strong>Considerations for licensors:</strong> Our public licenses are intended for use by those authorized to give the public permission to use material in ways otherwise restricted by copyright and certain other rights. Our licenses are irrevocable. Licensors should read and understand the terms and conditions of the license they choose before applying it. Licensors should also secure all rights necessary before applying our licenses so that the public can reuse the material as expected. Licensors should clearly mark any material not subject to the license. This includes other material, or material used under an exception or limitation to copyright. More considerations for licensors : wiki.creativecommons.org/Considerations_for_licensors</p>

                                        <p><strong>Considerations for the public:</strong> By using one of our public licenses, a licensor grants the public permission to use the licensed material under specified terms and conditions. If the licensor's permission is not necessary for any reason-for example, because of any applicable exception or limitation to copyright-then that use is not regulated by the license. Our licenses grant only permissions under copyright and certain other rights that a licensor has authority to grant. Use of the licensed material may still be restricted for other reasons, including because others have copyright or other rights in the material. A licensor may make special requests, such as asking that all changes be marked or described. Although not required by our licenses, you are encouraged to respect those requests where reasonable. More considerations for the public : wiki.creativecommons.org/Considerations_for_licensees</p>
                                    </div>
                                </div>

                                <div className="border-t pt-4">
                                    <h4 className="font-semibold mb-3">Creative Commons Attribution 4.0 International Public License</h4>
                                    <p className="text-sm leading-relaxed mb-4">
                                        By exercising the Licensed Rights (defined below), You accept and agree to be bound by the terms and conditions of this Creative Commons Attribution 4.0 International Public License ("Public License"). To the extent this Public License may be interpreted as a contract, You are granted the Licensed Rights in consideration of Your acceptance of these terms and conditions, and the Licensor grants You such rights in consideration of benefits the Licensor receives from making the Licensed Material available under these terms and conditions.
                                    </p>

                                    <div className="space-y-4">
                                        <div>
                                            <h5 className="font-medium mb-2">Section 1 - Definitions</h5>
                                            <div className="ml-4 space-y-2 text-sm leading-relaxed">

                                                <p><strong>a.</strong> Adapted Material means material subject to Copyright and Similar Rights that is derived from or based upon the Licensed Material and in which the Licensed Material is translated, altered, arranged, transformed, or otherwise modified in a manner requiring permission under the Copyright and Similar Rights held by the Licensor. For purposes of this Public License, where the Licensed Material is a musical work, performance, or sound recording, Adapted Material is always produced where the Licensed Material is synched in timed relation with a moving image.</p>
                                                <p><strong>b.</strong> Adapter's License means the license You apply to Your Copyright and Similar Rights in Your contributions to Adapted Material in accordance with the terms and conditions of this Public License.</p>
                                                <p><strong>c.</strong> Copyright and Similar Rights means copyright and/or similar rights closely related to copyright including, without limitation, performance, broadcast, sound recording, and Sui Generis Database Rights, without regard to how the rights are labeled or categorized. For purposes of this Public License, the rights specified in Section 2(b)(1)-(2) are not Copyright and Similar Rights.</p>
                                                <p><strong>d.</strong> Effective Technological Measures means those measures that, in the absence of proper authority, may not be circumvented under laws fulfilling obligations under Article 11 of the WIPO Copyright Treaty adopted on December 20, 1996, and/or similar international agreements.</p>
                                                <p><strong>e.</strong> Exceptions and Limitations means fair use, fair dealing, and/or any other exception or limitation to Copyright and Similar Rights that applies to Your use of the Licensed Material.</p>
                                                <p><strong>f.</strong> Licensed Material means the artistic or literary work, database, or other material to which the Licensor applied this Public License.</p>
                                                <p><strong>g.</strong> Licensed Rights means the rights granted to You subject to the terms and conditions of this Public License, which are limited to all Copyright and Similar Rights that apply to Your use of the Licensed Material and that the Licensor has authority to license.</p>
                                                <p><strong>h.</strong> Licensor means the individual(s) or entity(ies) granting rights under this Public License.</p>
                                                <p><strong>i.</strong> Share means to provide material to the public by any means or process that requires permission under the Licensed Rights, such as reproduction, public display, public performance, distribution, dissemination, communication, or importation, and to make material available to the public including in ways that members of the public may access the material from a place and at a time individually chosen by them.</p>
                                                <p><strong>j.</strong> Sui Generis Database Rights means rights other than copyright resulting from Directive 96/9/EC of the European Parliament and of the Council of 11 March 1996 on the legal protection of databases, as amended and/or succeeded, as well as other essentially equivalent rights anywhere in the world.</p>
                                                <p><strong>k.</strong> You means the individual or entity exercising the Licensed Rights under this Public License. Your has a corresponding meaning.</p>

                                            </div>
                                        </div>

                                        <div>
                                            <h5 className="font-medium mb-2">Section 2 - Scope</h5>
                                            <div className="ml-4 space-y-2 text-sm leading-relaxed">
                                                <p><strong>License grant:</strong> Subject to the terms and conditions of this Public License, the Licensor hereby grants You a worldwide, royalty-free, non-sublicensable, non-exclusive, irrevocable license to exercise the Licensed Rights in the Licensed Material to:</p>
                                                <div className="ml-4">

                                                    <p>A. reproduce and Share the Licensed Material, in whole or in part; and</p>
                                                    <p>B. produce, reproduce, and Share Adapted Material.</p>
                                                    <p>2. Exceptions and Limitations. For the avoidance of doubt, where Exceptions and Limitations apply to Your use, this Public License does not apply, and You do not need to comply with its terms and conditions.</p>
                                                    <p>3. Term. The term of this Public License is specified in Section 6(a).</p>
                                                    <p>4. Media and formats; technical modifications allowed. The Licensor authorizes You to exercise the Licensed Rights in all media and formats whether now known or hereafter created, and to make technical modifications necessary to do so. The Licensor waives and/or agrees not to assert any right or authority to forbid You from making technical modifications necessary to exercise the Licensed Rights, including technical modifications necessary to circumvent Effective Technological Measures. For purposes of this Public License, simply making modifications authorized by this Section 2(a)(4) never produces Adapted Material.</p>
                                                    <p>5. Downstream recipients.</p>
                                                    <p>A. Offer from the Licensor – Licensed Material. Every recipient of the Licensed Material automatically receives an offer from the Licensor to exercise the Licensed Rights under the terms and conditions of this Public License.</p>
                                                    <p>B. No downstream restrictions. You may not offer or impose any additional or different terms or conditions on, or apply any Effective Technological Measures to, the Licensed Material if doing so restricts exercise of the Licensed Rights by any recipient of the Licensed Material.</p>
                                                    <p>6. No endorsement. Nothing in this Public License constitutes or may be construed as permission to assert or imply that You are, or that Your use of the Licensed Material is, connected with, or sponsored, endorsed, or granted official status by, the Licensor or others designated to receive attribution as provided in Section 3(a)(1)(A)(i).</p>
                                                    <p>b. Other rights.</p>
                                                    <p>1. Moral rights, such as the right of integrity, are not licensed under this Public License, nor are publicity, privacy, and/or other similar personality rights; however, to the extent possible, the Licensor waives and/or agrees not to assert any such rights held by the Licensor to the limited extent necessary to allow You to exercise the Licensed Rights, but not otherwise.</p>
                                                    <p>2. Patent and trademark rights are not licensed under this Public License.</p>
                                                    <p>3. To the extent possible, the Licensor waives any right to collect royalties from You for the exercise of the Licensed Rights, whether directly or through a collecting society under any voluntary or waivable statutory or compulsory licensing scheme. In all other cases the Licensor expressly reserves any right to collect such royalties.</p>

                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <h5 className="font-medium mb-2">Section 3 - License Conditions</h5>
                                            <p className="text-sm leading-relaxed mb-4">Your exercise of the Licensed Rights is expressly made subject to the following conditions:</p>
                                            
                                            <div className="ml-4 space-y-4 text-sm leading-relaxed">
                                                <div>
                                                    <p className="font-medium mb-2"><strong>a. Attribution.</strong></p>
                                                    <div className="ml-4 space-y-3">
                                                        <div>
                                                            <p><strong>1.</strong> If You Share the Licensed Material (including in modified form), You must:</p>
                                                            <div className="ml-4 space-y-2 mt-2">
                                                                <div>
                                                                    <p><strong>A.</strong> retain the following if it is supplied by the Licensor with the Licensed Material:</p>
                                                                    <div className="ml-4 space-y-1 mt-2">
                                                                        <p><strong>i.</strong> identification of the creator(s) of the Licensed Material and any others designated to receive attribution, in any reasonable manner requested by the Licensor (including by pseudonym if designated);</p>
                                                                        <p><strong>ii.</strong> a copyright notice;</p>
                                                                        <p><strong>iii.</strong> a notice that refers to this Public License;</p>
                                                                        <p><strong>iv.</strong> a notice that refers to the disclaimer of warranties;</p>
                                                                        <p><strong>v.</strong> a URI or hyperlink to the Licensed Material to the extent reasonably practicable;</p>
                                                                    </div>
                                                                </div>
                                                                <p><strong>B.</strong> indicate if You modified the Licensed Material and retain an indication of any previous modifications; and</p>
                                                                <p><strong>C.</strong> indicate the Licensed Material is licensed under this Public License, and include the text of, or the URI or hyperlink to, this Public License.</p>
                                                            </div>
                                                        </div>
                                                        
                                                        <p><strong>2.</strong> You may satisfy the conditions in Section 3(a)(1) in any reasonable manner based on the medium, means, and context in which You Share the Licensed Material. For example, it may be reasonable to satisfy the conditions by providing a URI or hyperlink to a resource that includes the required information.</p>
                                                        
                                                        <p><strong>3.</strong> If requested by the Licensor, You must remove any of the information required by Section 3(a)(1)(A) to the extent reasonably practicable.</p>
                                                        
                                                        <p><strong>4.</strong> If You Share Adapted Material You produce, the Adapter's License You apply must not prevent recipients of the Adapted Material from complying with this Public License.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="border-t pt-6">
                                            <h5 className="font-medium mb-4">Section 4 - Sui Generis Database Rights</h5>
                                            <div className="space-y-3 text-sm leading-relaxed">
                                                <p>Where the Licensed Rights include Sui Generis Database Rights that apply to Your use of the Licensed Material:</p>
                                                <div className="ml-4 space-y-2">
                                                    <p><strong>a.</strong> for the avoidance of doubt, Section 2(a)(1) grants You the right to extract, reuse, reproduce, and Share all or a substantial portion of the contents of the database;</p>
                                                    <p><strong>b.</strong> if You include all or a substantial portion of the database contents in a database in which You have Sui Generis Database Rights, then the database in which You have Sui Generis Database Rights (but not its individual contents) is Adapted Material; and</p>
                                                    <p><strong>c.</strong> You must comply with the conditions in Section 3(a) if You Share all or a substantial portion of the contents of the database.</p>
                                                </div>
                                                <p>For the avoidance of doubt, this Section 4 supplements and does not replace Your obligations under this Public License where the Licensed Rights include other Copyright and Similar Rights.</p>
                                            </div>
                                        </div>

                                        <div className="bg-muted/30 p-4 rounded border-l-4 border-primary/20 mt-6">
                                            <h5 className="font-medium mb-4">Section 5 - Disclaimer of Warranties and Limitation of Liability</h5>
                                            <div className="space-y-3 text-sm leading-relaxed">
                                                <p><strong>a.</strong> Unless otherwise separately undertaken by the Licensor, to the extent possible, the Licensor offers the Licensed Material as-is and as-available, and makes no representations or warranties of any kind concerning the Licensed Material, whether express, implied, statutory, or other. This includes, without limitation, warranties of title, merchantability, fitness for a particular purpose, non-infringement, absence of latent or other defects, accuracy, or the presence or absence of errors, whether or not known or discoverable. Where disclaimers of warranties are not allowed in full or in part, this disclaimer may not apply to You.</p>
                                                <p><strong>b.</strong> To the extent possible, in no event will the Licensor be liable to You on any legal theory (including, without limitation, negligence) or otherwise for any direct, special, indirect, incidental, consequential, punitive, exemplary, or other losses, costs, expenses, or damages arising out of this Public License or use of the Licensed Material, even if the Licensor has been advised of the possibility of such losses, costs, expenses, or damages. Where a limitation of liability is not allowed in full or in part, this limitation may not apply to You.</p>
                                                <p><strong>c.</strong> The disclaimer of warranties and limitation of liability provided above shall be interpreted in a manner that, to the extent possible, most closely approximates an absolute disclaimer and waiver of all liability.</p>
                                            </div>
                                        </div>

                                        <div className="border-t pt-6">
                                            <h5 className="font-medium mb-4">Section 6 - Term and Termination</h5>
                                            <div className="space-y-3 text-sm leading-relaxed">
                                                <p><strong>a.</strong> This Public License applies for the term of the Copyright and Similar Rights licensed here. However, if You fail to comply with this Public License, then Your rights under this Public License terminate automatically.</p>
                                                <div>
                                                    <p><strong>b.</strong> Where Your right to use the Licensed Material has terminated under Section 6(a), it reinstates:</p>
                                                    <div className="ml-4 space-y-1 mt-2">
                                                        <p><strong>1.</strong> automatically as of the date the violation is cured, provided it is cured within 30 days of Your discovery of the violation; or</p>
                                                        <p><strong>2.</strong> upon express reinstatement by the Licensor.</p>
                                                    </div>
                                                </div>
                                                <p><strong>c.</strong> For the avoidance of doubt, this Section 6(b) does not affect any right the Licensor may have to seek remedies for Your violations of this Public License.</p>
                                                <p><strong>d.</strong> For the avoidance of doubt, the Licensor may also offer the Licensed Material under separate terms or conditions or stop distributing the Licensed Material at any time; however, doing so will not terminate this Public License.</p>
                                                <p><strong>e.</strong> Sections 1, 5, 6, 7, and 8 survive termination of this Public License.</p>
                                            </div>
                                        </div>

                                        <div className="border-t pt-6">
                                            <h5 className="font-medium mb-4">Section 7 - Other Terms and Conditions</h5>
                                            <div className="space-y-3 text-sm leading-relaxed">
                                                <p><strong>a.</strong> The Licensor shall not be bound by any additional or different terms or conditions communicated by You unless expressly agreed.</p>
                                                <p><strong>b.</strong> Any arrangements, understandings, or agreements regarding the Licensed Material not stated herein are separate from and independent of the terms and conditions of this Public License.</p>
                                            </div>
                                        </div>

                                        <div className="border-t pt-6">
                                            <h5 className="font-medium mb-4">Section 8 - Interpretation</h5>
                                            <div className="space-y-3 text-sm leading-relaxed">
                                                <p><strong>a.</strong> For the avoidance of doubt, this Public License does not, and shall not be interpreted to, reduce, limit, restrict, or impose conditions on any use of the Licensed Material that could lawfully be made without permission under this Public License.</p>
                                                <p><strong>b.</strong> To the extent possible, if any provision of this Public License is deemed unenforceable, it shall be automatically reformed to the minimum extent necessary to make it enforceable. If the provision cannot be reformed, it shall be severed from this Public License without affecting the enforceability of the remaining terms and conditions.</p>
                                                <p><strong>c.</strong> No term or condition of this Public License will be waived and no failure to comply consented to unless expressly agreed to by the Licensor.</p>
                                                <p><strong>d.</strong> Nothing in this Public License constitutes or may be interpreted as a limitation upon, or waiver of, any privileges and immunities that apply to the Licensor or You, including from the legal processes of any jurisdiction or authority.</p>
                                            </div>
                                        </div>

                                       
                                    </div>

                                    <div className="mt-4 pt-4 border-t text-xs text-muted-foreground">
                                        <p>Creative Commons may be contacted at creativecommons.org.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-6 text-foreground/80 mt-8">
                            <h2 className="font-bold text-foreground mb-2">Components Under BlueOak License</h2>

                            <div className="overflow-x-auto rounded-lg border">
                                <table className="min-w-full divide-y divide-border text-sm">
                                    <tbody className="divide-y divide-border">
                                        <tr className="align-top">
                                            <td className="px-4 py-3">chownr 3.0.0 (BlueOak-1.0.0)</td>
                                        </tr>
                                        <tr className="align-top">
                                            <td className="px-4 py-3">yallist 5.0.0 (BlueOak-1.0.0)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="space-y-6 text-foreground/80 mt-8">
                            <h2 className="font-bold text-foreground mb-4">BlueOak License Version 1.0.0</h2>

                            <div className="rounded-lg border bg-muted/50 p-6 space-y-6">
                                <div>
                                    <h3 className="font-semibold text-lg mb-4">Purpose</h3>
                                    <p className="text-sm leading-relaxed">
                                        This license gives everyone as much permission to work with this software as possible, while protecting contributors from liability.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <h4 className="font-medium mb-2">Acceptance</h4>
                                        <p className="text-sm leading-relaxed">
                                            In order to receive this license, you must agree to its rules. The rules of this license are both obligations under that agreement and conditions to your license. You must not do anything with this software that triggers a rule that you cannot or will not follow.
                                        </p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">Copyright</h4>
                                        <p className="text-sm leading-relaxed">
                                            Each contributor licenses you to do everything with this software that would otherwise infringe that contributor's copyright in it.
                                        </p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">Notices</h4>
                                        <p className="text-sm leading-relaxed">
                                            You must ensure that everyone who gets a copy of any part of this software from you, with or without changes, also gets the text of this license or a link to https://blueoakcouncil.org/license/1.0.0.
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-medium mb-2">Excuse</h4>
                                        <p className="text-sm leading-relaxed">
                                            If anyone notifies you in writing that you have not complied with [Notices](#notices), you can keep your license by taking all practical steps to comply within 30 days after the notice.  If you do not do so, your license ends immediately.
                                        </p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">Patent</h4>
                                        <p className="text-sm leading-relaxed">
                                            Each contributor licenses you to do everything with this software that would otherwise infringe any patent claims they can license or become able to license.
                                        </p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">Reliability</h4>
                                        <p className="text-sm leading-relaxed">
                                            No contributor can revoke this license.
                                        </p>
                                    </div>

                                    <div className="bg-muted/30 p-4 rounded border-l-4 border-primary/20">
                                        <h4 className="font-medium mb-2">No Liability</h4>
                                        <p className="text-sm leading-relaxed font-medium">
                                            As far as the law allows, this software comes as is, without any warranty or condition, and no contributor will be liable to anyone for any damages related to this software or this license, under any kind of legal claim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="space-y-6 text-foreground/80  mt-4">
                        <h2 className=" font-bold text-foreground mb-2">Components under MPL 2.0 License</h2>

                        <div className="overflow-x-auto rounded-lg border">
                            <table className="min-w-full divide-y divide-border text-sm">

                                <tbody className="divide-y divide-border">
                                    {MPL2_LICENSE_LIST.map((row, rowIndex) => (
                                        <tr key={rowIndex} className="align-top">
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className="px-4 py-3">
                                                    {cell}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="space-y-6 text-foreground/80 mt-8">
                        <h2 className="font-bold text-foreground mb-4">Mozilla Public License Version 2.0</h2>

                        <div className="rounded-lg border bg-muted/50 p-6 space-y-6">
                            <div>
                                <h3 className="font-semibold text-lg mb-4">1. Definitions</h3>
                                <div className="ml-4 space-y-3 text-sm leading-relaxed">
                                    <p><strong>1.1.</strong> "Contributor" means each individual or legal entity that creates, contributes to the creation of, or owns Covered Software.</p>
                                    <p><strong>1.2.</strong> "Contributor Version" means the combination of the Contributions of others (if any) used by a Contributor and that particular Contributor's Contribution.</p>
                                    <p><strong>1.3.</strong> "Contribution" means Covered Software of a particular Contributor.</p>
                                    <p><strong>1.4.</strong> "Covered Software" means Source Code Form to which the initial Contributor has attached the notice in Exhibit A, the Executable Form of such Source Code Form, and Modifications of such Source Code Form, in each case including portions thereof.</p>
                                    <p><strong>1.5.</strong> "Incompatible With Secondary Licenses" means
                                        <ul>
                                            <li><strong>(a)</strong> that the initial Contributor has attached the notice described in Exhibit B to the Covered Software; or</li>
                                            <li><strong>(b)</strong> that the Covered Software was made available under the terms of version 1.1 or earlier of the License, but not also under the terms of a Secondary License.</li>
                                        </ul>
                                    </p>
                                    <p><strong>1.6.</strong> "Executable Form" means any form of the work other than Source Code Form.</p>
                                    <p><strong>1.7.</strong> "Larger Work" means a work that combines Covered Software with other material, in a separate file or files, that is not Covered Software.</p>
                                    <p><strong>1.8.</strong> "License" means this document.</p>
                                    <p><strong>1.9.</strong> "Licensable" means having the right to grant, to the maximum extent possible, whether at the time of the initial grant or subsequently, any and all of the rights conveyed by this License.</p>
                                    <p><strong>1.10.</strong> "Modifications" means any of the following:
                                        <ul>
                                            <li><strong>(a)</strong> any file in Source Code Form that results from an addition to, deletion from, or modification of the contents of Covered Software; or</li>
                                            <li><strong>(b)</strong> any new file in Source Code Form that contains any Covered Software.</li>
                                        </ul>


                                    </p>
                                    <p><strong>1.11.</strong> "Patent Claims" of a Contributor means any patent claim(s), including without limitation, method, process, and apparatus claims, in any patent Licensable by such Contributor that would be infringed, but for the grant of the License, by the making, using, selling, offering for sale, having made, import, or transfer of either its Contributions or its Contributor Version.</p>
                                    <p><strong>1.12.</strong> "Secondary License" means either the GNU General Public License, Version 2.0, the GNU Lesser General Public License, Version 2.1, the GNU Affero General Public License, Version 3.0, or any later versions of those licenses.</p>
                                    <p><strong>1.13.</strong> "Source Code Form" means the form of the work preferred for making modifications.</p>
                                    <p><strong>1.14.</strong> "You" (or "Your") means an individual or a legal entity exercising rights under this License.  For legal entities, "You" includes any entity that controls, is controlled by, or is under common control with You. For purposes of this definition, "control" means (a) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (b) ownership of more than fifty percent (50%) of the outstanding shares or beneficial ownership of such entity.</p>
                                </div>
                            </div>

                            <div className="border-t pt-6">
                                <h3 className="font-semibold text-lg mb-4">2. License Grants and Conditions</h3>
                                <div className="space-y-4">
                                    <div>
                                        <h4 className="font-medium mb-2">2.1. Grants</h4>
                                        <p className="text-sm leading-relaxed mb-2">Each Contributor hereby grants You a world-wide, royalty-free, non-exclusive license:</p>
                                        <div className="ml-4 space-y-2 text-sm leading-relaxed">
                                            <p><strong>(a)</strong> under intellectual property rights (other than patent or trademark) Licensable by such Contributor to use, reproduce, make available, modify, display, perform, distribute, and otherwise exploit its Contributions, either on an unmodified basis, with Modifications, or as part of a Larger Work; and</p>
                                            <p><strong>(b)</strong> under Patent Claims of such Contributor to make, use, sell, offer for sale, have made, import, and otherwise transfer either its Contributions or its Contributor Version.</p>
                                        </div>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">2.2. Effective Date</h4>
                                        <p className="text-sm leading-relaxed">The licenses granted in Section 2.1 with respect to any Contribution become effective for each Contribution on the date the Contributor first distributes such Contribution.</p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">2.3. Limitations on Grant Scope</h4>
                                        <p className="text-sm leading-relaxed mb-2">The licenses granted in this Section 2 are the only rights granted under this License. No additional rights or licenses will be implied from the distribution or licensing of Covered Software under this License. Notwithstanding Section 2.1(b) above, no patent license is granted by a Contributor:</p>

                                        <div className="ml-4 space-y-2 text-sm leading-relaxed">
                                            <p><strong>(a)</strong> for any code that a Contributor has removed from Covered Software; or</p>
                                            <p><strong>(b)</strong> for infringements caused by: (i) Your and any other third party's modifications of Covered Software, or (ii) the combination of its Contributions with other software (except as part of its Contributor Version); or</p>
                                            <p><strong>(c)</strong> under Patent Claims infringed by Covered Software in the absence of its Contributions.</p>
                                        </div>

                                        <p className="text-sm leading-relaxed mb-2">This License does not grant any rights in the trademarks, service marks, or logos of any Contributor (except as may be necessary to comply with the notice requirements in Section 3.4).
                                        </p>
                                    </div>



                                    <div>
                                        <h4 className="font-medium mb-2">2.4. Subsequent Licenses</h4>
                                        <p className="text-sm leading-relaxed">No Contributor makes additional grants as a result of Your choice to distribute the Covered Software under a subsequent version of this License (see Section 10.2) or under the terms of a Secondary License (if permitted under the terms of Section 3.3).</p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">2.5. Representation</h4>
                                        <p className="text-sm leading-relaxed">Each Contributor represents that the Contributor believes its Contributions are its original creation(s) or it has sufficient rights to grant the rights to its Contributions conveyed by this License.</p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">2.6. Fair Use</h4>
                                        <p className="text-sm leading-relaxed">This License is not intended to limit any rights You have under applicable copyright doctrines of fair use, fair dealing, or other equivalents.</p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-2">2.7. Conditions</h4>
                                        <p className="text-sm leading-relaxed">Sections 3.1, 3.2, 3.3, and 3.4 are conditions of the licenses granted in Section 2.1.</p>
                                    </div>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">3. Responsibilities</h3>
                                    <div className="space-y-4">
                                        <div>
                                            <h4 className="font-medium mb-2">3.1. Distribution of Source Form</h4>
                                            <p className="text-sm leading-relaxed">All distribution of Covered Software in Source Code Form, including any Modifications that You create or to which You contribute, must be under the terms of this License. You must inform recipients that the Source Code Form of the Covered Software is governed by the terms of this License, and how they can obtain a copy of this License. You may not attempt to alter or restrict the recipients' rights in the Source Code Form.
                                            </p>
                                        </div>

                                        <div>
                                            <h4 className="font-medium mb-2">3.2. Distribution of Executable Form</h4>

                                            <p className="text-sm leading-relaxed">If You distribute Covered Software in Executable Form then:</p>
                                            <p className="text-sm leading-relaxed">(a) such Covered Software must also be made available in Source Code Form, as described in Section 3.1, and You must inform recipients of the Executable Form how they can obtain a copy of such Source Code Form by reasonable means in a timely manner, at a charge no more than the cost of distribution to the recipient; and</p>
                                            <p className="text-sm leading-relaxed">(b) You may distribute such Executable Form under the terms of this License, or sublicense it under different terms, provided that the license for the Executable Form does not attempt to limit or alter the recipients' rights in the Source Code Form under this License.</p>

                                        </div>

                                        <div>
                                            <h4 className="font-medium mb-2">3.3. Distribution of a Larger Work</h4>
                                            <p className="text-sm leading-relaxed">You may create and distribute a Larger Work under terms of Your choice, provided that You also comply with the requirements of this License for the Covered Software. If the Larger Work is a combination of Covered Software with a work governed by one or more Secondary Licenses, and the Covered Software is not Incompatible With Secondary Licenses, this License permits You to additionally distribute such Covered Software under the terms of such Secondary License(s), so that the recipient of the Larger Work may, at their option, further distribute the Covered Software under the terms of either this License or such Secondary License(s).</p>
                                        </div>

                                        <div>
                                            <h4 className="font-medium mb-2">3.4. Notices</h4>
                                            <p className="text-sm leading-relaxed">You may not remove or alter the substance of any license notices (including copyright notices, patent notices, disclaimers of warranty, or limitations of liability) contained within the Source Code Form of the Covered Software, except that You may alter any license notices to the extent required to remedy known factual inaccuracies.</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium mb-2">3.5. Application of Additional Terms</h4>
                                            <p className="text-sm leading-relaxed">You may choose to offer, and to charge a fee for, warranty, support, indemnity or liability obligations to one or more recipients of Covered Software. However, You may do so only on Your own behalf, and not on behalf of any Contributor. You must make it absolutely clear that any such warranty, support, indemnity, or liability obligation is offered by You alone, and You hereby agree to indemnify every Contributor for any liability incurred by such Contributor as a result of warranty, support, indemnity or liability terms You offer. You may include additional disclaimers of warranty and limitations of liability specific to any jurisdiction.</p>
                                        </div>

                                    </div>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">4. Inability to Comply Due to Statute or Regulation</h3>
                                    <p className="text-sm leading-relaxed">If it is impossible for You to comply with any of the terms of this License with respect to some or all of the Covered Software due to statute, judicial order, or regulation then You must: (a) comply with the terms of this License to the maximum extent possible; and (b) describe the limitations and the code they affect.</p>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">5. Termination</h3>
                                   
                                    <p className="text-sm leading-relaxed">5.1. The rights granted under this License will terminate automatically if You fail to comply with any of its terms. However, if You become compliant, then the rights granted under this License from a particular Contributor are reinstated (a) provisionally, unless and until such Contributor explicitly and finally terminates Your grants, and (b) on an ongoing basis, if such Contributor fails to notify You of the non-compliance by some reasonable means prior to 60 days after You have come back into compliance. Moreover, Your grants from a particular Contributor are reinstated on an ongoing basis if such Contributor notifies You of the non-compliance by some reasonable means, this is the first time You have received notice of non-compliance with this License from such Contributor, and You become compliant prior to 30 days after Your receipt of the notice.</p>
                                    <p className="text-sm leading-relaxed">5.2. If You initiate litigation against any entity by asserting a patent infringement claim (excluding declaratory judgment actions, counter-claims, and cross-claims) alleging that a Contributor Version directly or indirectly infringes any patent, then the rights granted to You by any and all Contributors for the Covered Software under Section 2.1 of this License shall terminate.</p>
                                    <p className="text-sm leading-relaxed">5.3. In the event of termination under Sections 5.1 or 5.2 above, all end user license agreements (excluding distributors and resellers) which have been validly granted by You or Your distributors under this License prior to termination shall survive termination.</p>

                              
                                </div>

                                <div className="border-t pt-6 bg-muted/30 -m-6 p-6 rounded-b-lg">
                                    <h3 className="font-semibold text-lg mb-4">6. Disclaimer of Warranty</h3>
                                    <p className="text-sm leading-relaxed mb-4">Covered Software is provided under this License on an "as is" basis, without warranty of any kind, either expressed, implied, or statutory, including, without limitation, warranties that the Covered Software is free of defects, merchantable, fit for a particular purpose or non-infringing. The entire risk as to the quality and performance of the Covered Software is with You. Should any Covered Software prove defective in any respect, You (not any Contributor) assume the cost of any necessary servicing, repair, or correction. This disclaimer of warranty constitutes an essential part of this License. No use of any Covered Software is authorized under this License except under this disclaimer.</p>

                                    <h3 className="font-semibold text-lg mb-4">7. Limitation of Liability</h3>
                                    <p className="text-sm leading-relaxed mb-4">Under no circumstances and under no legal theory, whether tort (including negligence), contract, or otherwise, shall any Contributor, or anyone who distributes Covered Software as permitted above, be liable to You for any direct, indirect, special, incidental, or consequential damages of any character including, without limitation, damages for lost profits, loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses, even if such party shall have been informed of the possibility of such damages. This limitation of liability shall not apply to liability for death or personal injury resulting from such party's negligence to the extent applicable law prohibits such limitation. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so this exclusion and limitation may not apply to You.</p>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">8. Litigation</h3>
                                    <p className="text-sm leading-relaxed">Any litigation relating to this License may be brought only in the courts of a jurisdiction where the defendant maintains its principal place of business and such litigation shall be governed by laws of that jurisdiction, without reference to its conflict-of-law provisions. Nothing in this Section shall prevent a party's ability to bring cross-claims or counter-claims.</p>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">9. Miscellaneous</h3>
                                    <p className="text-sm leading-relaxed">This License represents the complete agreement concerning the subject matter hereof. If any provision of this License is held to be unenforceable, such provision shall be reformed only to the extent necessary to make it enforceable. Any law or regulation which provides that the language of a contract shall be construed against the drafter shall not be used to construe this License against a Contributor.</p>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">10. Versions of the License</h3>
                                    <div className="space-y-3">
                                        <div>
                                            <h4 className="font-medium mb-2">10.1. New Versions</h4>
                                            <p className="text-sm leading-relaxed">Mozilla Foundation is the license steward. Except as provided in Section 10.3, no one other than the license steward has the right to modify or publish new versions of this License. Each version will be given a distinguishing version number.</p>
                                        </div>

                                        <div>
                                            <h4 className="font-medium mb-2">10.2. Effect of New Versions</h4>
                                            <p className="text-sm leading-relaxed">You may distribute the Covered Software under the terms of the version of the License under which You originally received the Covered Software, or under the terms of any subsequent version published by the license steward.</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium mb-2">10.3. Modified Versions</h4>
                                            <p className="text-sm leading-relaxed">If you create software not governed by this License, and you want to create a new license for such software, you may create and use a modified version of this License if you rename the license and remove any references to the name of the license steward (except to note that such modified license differs from this License).</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium mb-2">10.4. Distributing Source Code Form that is Incompatible With Secondary Licenses</h4>
                                            <p className="text-sm leading-relaxed">If You choose to distribute Source Code Form that is Incompatible With Secondary Licenses under the terms of this version of the License, the notice described in Exhibit B of this License must be attached.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t pt-6">
                                    <h3 className="font-semibold text-lg mb-4">Exhibits</h3>
                                    <div className="space-y-4">
                                        <div>
                                            <h4 className="font-medium mb-2">Exhibit A - Source Code Form License Notice</h4>
                                            <div className="bg-muted/30 p-4 rounded text-sm font-mono leading-relaxed border-l-4 border-primary/20">
                                                <p>This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.</p>
                                            </div>

                                            <p>If it is not possible or desirable to put the notice in a particular file, then You may include the notice in a location (such as a LICENSE file in a relevant directory) where a recipient would be likely to look for such a notice.
                                                You may add additional accurate notices of copyright ownership.</p>
                                        </div>

                                        <div>
                                            <h4 className="font-medium mb-2">Exhibit B - "Incompatible With Secondary Licenses" Notice</h4>
                                            <div className="bg-muted/30 p-4 rounded text-sm font-mono leading-relaxed border-l-4 border-primary/20">
                                                <p>This Source Code Form is "Incompatible With Secondary Licenses", as defined by the Mozilla Public License, v. 2.0.</p>
                                            </div>
                                        </div>
                                        <div>
                                            <h4 className="font-medium mb-2">Standard License Header</h4>
                                            <div className="bg-muted/30 p-4 rounded text-sm font-mono leading-relaxed border-l-4 border-primary/20">
                                                <p>This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>
    );
}
